import { useState, useEffect, useRef, forwardRef, useCallback } from "react";
import styles from "../RightSidebar/rightsidebar.module.css";
import BorderedButton from "../Buttons/BorderedButton";
import PrimaryButton from "../Buttons/PrimaryButton";
import DateTimeOutletSelector from "./DateTimeOutletSelector";
import CustomerSelector from "./CustomerSelector";
import { toast } from "react-toastify";
import { useGlobalContext } from "../../Context/GlobalContext";
import {
	postBookingData,
	postpaymentData,
	cancelBookingData,
	deleteBooking,
	postBookingStatus,
	postApplyDiscountToBooking,
	refundRequest,
	addSaleNote,
	createTemporaryBooking,
	updateTemporaryBooking,
	getGuestCheckinList,
	getBookingDetail2,
	deleteHoldBooking,
} from "../../APICalling/APICalling";
import ServiceSelector from "./ServiceSelector/ServiceSelector";
import SourceSelector from "./SourceSelector";
import PriceSummary from "./PriceSummary";
import BookingInfo from "./BookingInfo";
import PaymentPage from "./PaymentPage";
import CheckoutPage from "./CheckoutPage";
import ConfirmationPage from "./ConfirmationPage";
import Notes from "./Notes";
import CancelBookingPopup from "../Popups/CancelBookingPopup/CancelBookingPopup";
import EditSidebarWrapper from "./EditSidebarWrapper";
import SaleInfoPage from "./SaleInfoPage";
import { formatDateToDDMMYYYY, getTimeSelectionDayOffset, scrollToBooking, updateBookingStatus, convertToMinutes, calculateEndTime, roundCashAmount, ensureDateObject, buildTimeSelection, extractHHMM, convertTo12Hour, getOutletExtendedFlagForDate, isBookingAlreadyCompletedResponse } from "../../Utils/utils";
import { findLiveBookingListEntry, buildLiveGuestTagMap, mergeLiveGuestTagIntoBookingItemMap } from "../../Utils/liveGuestCheckinTag";
import {
	clearCheckoutCustomerIsPasswordSet,
	fetchAndStoreCheckoutCustomerPasswordFlag,
	enrichCustomerWithCheckoutPasswordFlag,
	storeCheckoutPasswordFlagFromCustomer,
} from "../../Utils/customerPasswordSession";
import { buildSeededPricingOverrides, hasBookingPriceAdjustmentObject, mergePricingOverrideMap } from "./checkoutPricingModifiers";
import { buildMembershipIdPaymentFields } from "../../Utils/customerSearchUtils";
import {
	refreshCustomerCreditDetailsFromUser,
	computeRemainingCheckoutAmount,
	membershipClientToTopupCustomer,
	fetchMembershipClientCreditPatch,
} from "../../Utils/customerCreditRefresh";
import DiscardPaymentPopup from "../Popups/DiscardPaymentPopup/DiscardPaymentPopup";
import CancelBookingWithRefund from "../Popups/CancelBookingPopup/CancelBookingWithRefund";
import ConfirmedAgainPopup from "../Popups/ConfirmedAgainPopup/ConfirmedAgainPopup";
import SaleNotePopup from "../Popups/SaleNotePopup/SaleNotePopup";
import VoidSalePopup from "../Popups/CancelBookingPopup/VoidSalePopup";
import RepeatBookingPopup from "../Popups/RepeatBookingPopup/RepeatBookingPopup";
import CustomerDetailsModal from "../CustomerDetailsModal/CustomerDetailsModal";
import BackIcon from "../../Assets/images/back.svg";
import { getOpenMembershipRecoveryIds } from "../../Utils/openMembershipSale";
import CompletedBookingCanEditPopup from "../Popups/CompletedBookingCanEditPopup/CompletedBookingCanEditPopup";
import { getBookingPreventChanges } from "../../Utils/BookingPreventChanges";
import logger from "../../Utils/logger";

const DEFAULT_PAYMENT_SUMMARY = {
	subtotal: 0,
	midtotal: 0,
	gst: 0,
	tip: "0.00",
	total: 0,
	payment_method: "",
};
const getApiSuccess = (response) => response?.data?.success ?? response?.success;
const getApiMessage = (response, fallback = "Something went wrong. Please try again.") => response?.message || response?.data?.message || fallback;

const RightSidebarWrapper = forwardRef(
	(
		{
			interval,
			show,
			bookingId,
			bookingsList,
			staffTiming,
			onClose,
			onClearSidebarSelection,
			setSelectedCells,
			editPrefill,
			breaksData = [],
			setIsBookingSubmitting,
			isOutletExtended,
			mainContentRef,
		},
		ref
	) => {
		const {
			apiError,
			setApiError,
			itemData,
			setItemData,
			resetBookingForm,
			items,
			bookingData,
			setNewAppointmentSlots,
			setNewSlot,
			loggedUser,
			setBookingsList,
			triggerCancel,
			setTriggerCancel,
			paymentSummary,
			setPaymentSummary,
			paymentHistory,
			setPaymentHistory,
			currentPaymentMethod,
			currentPaymentMethodId,
			setCurrentPaymentMethod,
			setCurrentPaymentMethodTitle,
			setCurrentPaymentMethodId,
			amountDue,
			setAmountDue,
			amountToCharge,
			setReference,
			selectedServices,
			setSelectedServices,
			paxes,
			setPaxes,
			bookingChanged,
			setBookingChanged,
			setRightSidebarOpen,
			setDeletedBookingID,
			setIsNewBookingSlotActive,
			isSidebarLoading,
			setVoucherStates,
			setVoucherDetail,
			selectedBookingId,setSelectedBookingId,
			selectedSaleId, setSelectedSaleId,
			createdBooking, setCreatedBooking,
			setIsEditBookingActive,
			selectedRemark,
			selectedReason,
			setSelectedRemark,
			setSelectedReason,
			selectedDate,
			setSelectedDate,
			selectedTime,
			selectedOutlet,
			setIsCustomerSelected,
			voucherDetail,
			setShowBookingSummary,
			setSidebarLoading,
			isBookingInfoUpdated, setIsBookingInfoUpdated,
			customerData,
			setCustomerData,
			homeStaffList,
			setSelectedTime,
			selectedOutletData,
			setEditPrefill,
			setShowConflictModal,
			isMembershipApplied,
			isGreyBox,
			isRoomFilterActive,
			isViewOnlyOutlet,
			selectedTherapistFromRow,
			setNoRoomSelected,
			newAppointmentSlots,
			isCustomerSelected,
			hitTemporaryBookingApi, setHitTemporaryBookingApi,
			tempBookingCreated, setTempBookingCreated,
			localSessionId,
			temporaryBookingId, setTemporaryBookingId,
			setEditableBooking,
			editableBooking,
			isEditBookingActive,
			setDateSyncState,
			selectedBookingDeleteScope,
			setSelectedBookingDeleteScope,
			setSelectedBookingUpdateScope,
			guestCheckinList,
			setGuestCheckinList,
			selectedGuestCheckin,
			setSelectedGuestCheckin,
			editLoading,
			showCancelPopup, setShowCancelPopup,
			setBookingDataFromAPI,
			bookingDetails, setBookingDetails,
			customerBookingItems,
			setCustomerBookingItems,
			newBookingActive,
			setNewBookingActive,
			setIsSidebarVisible,
			setDiscountItemToPost,
			setDiscountByBookingItemId,
			setManualCommissionByBookingItemId,
			setClearedEditedCommissionByBookingItemId,
			discountItemToPost,
			setMemberRateByBookingItemId,
			setServiceTotal,
			setAmountToCharge,
			setCustomerCreditDetails,
			setCompleteBookingWarning,
			setShowPaymentInProgressNotice,
			setIsAutoApply,
			setDeletedBookingItemIds,
		} = useGlobalContext();

	const sidebarRef = useRef();
	const scrollableRef = useRef();
	const bottomRef = useRef();
	const lastResetBookingIdRef = useRef(null);
	const skipDetailFetchForIdRef = useRef(null);
	/** Booking id for which getBookingDetail2 already succeeded (skip repeat fetches on drag). */
	const hydratedBookingDetailsIdRef = useRef(null);
	/** Monotonic generation so late booking-details responses are ignored. */
	const bookingDetailsFetchGenRef = useRef(0);
	/** Prevents duplicate in-flight getBookingDetail2 for the same booking id. */
	const bookingDetailsInFlightIdRef = useRef(null);
	const selectedBookingIdRef = useRef(selectedBookingId);
	selectedBookingIdRef.current = selectedBookingId;
	const editBookingSnapshotRef = useRef(null);
	const bookingDetailsRef = useRef(bookingDetails);
	bookingDetailsRef.current = bookingDetails;
	const checkoutPaymentMethodBeforeTopupRef = useRef({ method: "", id: null });
	const checkoutAmountsBeforeTopupRef = useRef({ amountDue: null, amountToCharge: null });
	const checkoutTopupTargetCustomerRef = useRef(null);
	const [guestCheckinPagination, setGuestCheckinPagination] = useState(null);
	const [guestCheckinLoadingMore, setGuestCheckinLoadingMore] = useState(false);
	const guestCheckinListRequestIdRef = useRef(0);
	const guestCheckinSearchDebounceRef = useRef(null);
	const lastGuestCheckinSearchRef = useRef("");
	const guestCheckinAppendInFlightRef = useRef(false);
	const setSidebarNode = useCallback((node) => {
		sidebarRef.current = node;
		if (typeof ref === "function") {
			ref(node);
		} else if (ref) {
			ref.current = node;
		}
	}, [ref]);
	const hideSidebar = useCallback(() => {
		// Invalidate any in-flight booking-details so a late response cannot overwrite drag state.
		bookingDetailsFetchGenRef.current += 1;
		bookingDetailsInFlightIdRef.current = null;
		setSidebarLoading(false);
		if (typeof onClearSidebarSelection === "function") {
			onClearSidebarSelection();
		}
		setIsSidebarVisible(false);
		setRightSidebarOpen(false);
		try {
			document.body.classList.remove("rightsidebar-open");
		} catch {}
	}, [onClearSidebarSelection, setIsSidebarVisible, setRightSidebarOpen, setSidebarLoading]);
	const resetCheckoutPricingState = useCallback(() => {
		setDiscountByBookingItemId({});
		setMemberRateByBookingItemId({});
		setManualCommissionByBookingItemId({});
		setClearedEditedCommissionByBookingItemId({});
		setDiscountItemToPost([]);
	}, [
		setClearedEditedCommissionByBookingItemId,
		setDiscountByBookingItemId,
		setManualCommissionByBookingItemId,
		setMemberRateByBookingItemId,
		setDiscountItemToPost,
	]);
	const resetCheckoutState = useCallback(() => {
		setServiceTotal(0);
		setAmountDue(0);
		setAmountToCharge("");
		setReference("");
		setPaymentSummary(DEFAULT_PAYMENT_SUMMARY);
		setPaymentHistory([]);
		setCurrentPaymentMethod("");
		setCurrentPaymentMethodTitle("");
		setCurrentPaymentMethodId(null);
		setVoucherDetail([]);
		setVoucherStates({});
		resetCheckoutPricingState();
	}, [
		resetCheckoutPricingState,
		setAmountDue,
		setAmountToCharge,
		setCurrentPaymentMethod,
		setCurrentPaymentMethodTitle,
		setCurrentPaymentMethodId,
		setPaymentHistory,
		setPaymentSummary,
		setReference,
		setServiceTotal,
		setVoucherDetail,
		setVoucherStates,
	]);
	const resetActiveEditBookingContext = useCallback((nextBookingId = null) => {
		const currentEditableBookingId = editableBooking?.id ?? null;
		if (!currentEditableBookingId) return;
		if (nextBookingId != null && String(currentEditableBookingId) === String(nextBookingId)) return;
		try {
			window.dispatchEvent(new CustomEvent("cancelEditOverride", {detail: { bookingId: currentEditableBookingId },}));
		} catch {}
		setSelectedServices([]);
		setPaxes([]);
		setEditPrefill(null);
		setEditableBooking(null);
		setSelectedGuestCheckin({});
	}, [editableBooking?.id,setEditPrefill,setEditableBooking,setPaxes,setSelectedGuestCheckin,setSelectedServices,]);

	const normalizeNumericId = useCallback((value) => {
		if (value == null || value === "") return null;
		if (typeof value === "object") {
			const nestedValue = value?.value ?? value?.id ?? value?.item_id ?? value?.room_id ?? null;
			if (nestedValue == null || nestedValue === "") return null;
			const normalizedNested = Number(nestedValue);
			return Number.isNaN(normalizedNested) ? null : normalizedNested;
		}
		const normalized = Number(value);
		return Number.isNaN(normalized) ? null : normalized;
	}, []);

	const normalizeComparableId = useCallback((value) => {
		const numeric = normalizeNumericId(value);
		if (numeric != null) return String(numeric);
		if (value == null) return null;
		const normalized = String(value).trim();
		return normalized || null;
	}, [normalizeNumericId]);

	const getServiceTherapistId = useCallback((service) => (
		normalizeComparableId(
			service?.therapist ??
			service?.therapist_id ??
			service?.staff_id ??
			service?.selected_therapist?.value ??
			service?.selected_therapist?.id ??
			null
		)
	), [normalizeComparableId]);

	const getServiceRoomId = useCallback((service) => (
		normalizeComparableId(
			service?.roomId ??
			service?.room ??
			service?.room_id ??
			service?.room_segments?.[0]?.room_id ??
			service?.room_items?.[0]?.item_id ??
			service?.room_items?.[0]?.room_id ??
			null
		)
	), [normalizeComparableId]);

	const hasServiceRoomAssignment = useCallback((service) => (
		getServiceRoomId(service) != null ||
		(Array.isArray(service?.room_segments) && service.room_segments.length > 0)
	), [getServiceRoomId]);

	const getAllDraftServices = useCallback(() => ([
		...(selectedServices || []),
		...(paxes || []).flatMap((p) => p.selectedServices || []),
	]), [selectedServices, paxes]);

	const parseDatePart = useCallback((datePart) => {
		if (!datePart || typeof datePart !== "string") return null;

		if (/^\d{2}-\d{2}-\d{4}$/.test(datePart)) {
			const [day, month, year] = datePart.split("-").map(Number);
			const parsed = new Date(year, month - 1, day);
			return Number.isNaN(parsed.getTime()) ? null : parsed;
		}

		if (/^\d{4}-\d{2}-\d{2}$/.test(datePart)) {
			const [year, month, day] = datePart.split("-").map(Number);
			const parsed = new Date(year, month - 1, day);
			return Number.isNaN(parsed.getTime()) ? null : parsed;
		}

		return null;
	}, []);

	const getItemCalendarExpansionFlag = useCallback((item) => {
		const selectedBaseDate = selectedDate instanceof Date ? new Date(selectedDate) : new Date(selectedDate || null);
		if (Number.isNaN(selectedBaseDate.getTime())) {
			return 0;
		}

		const normalizedBaseDate = new Date(
			selectedBaseDate.getFullYear(),
			selectedBaseDate.getMonth(),
			selectedBaseDate.getDate()
		);

		const itemDatePart =
			typeof item?.service_at === "string"
				? item.service_at.split(" ")[0]
				: item?.start_date || null;
		const itemDate = parseDatePart(itemDatePart);
		if (itemDate) {
			const normalizedFirstItemDate = new Date(
				itemDate.getFullYear(),
				itemDate.getMonth(),
				itemDate.getDate()
			);

			if (normalizedFirstItemDate.getTime() > normalizedBaseDate.getTime()) {
				return 1;
			}
		}

		if (typeof item?.dayOffset === "number" && item.dayOffset > 0) {
			return 1;
		}

		if (typeof item?.absoluteMinutes === "number" && !Number.isNaN(item.absoluteMinutes)) {
			const itemDayOffsetFromAbsolute = Math.max(0, Math.floor(item.absoluteMinutes / 1440));
			if (itemDayOffsetFromAbsolute > 0) {
				return 1;
			}
		}

		if (typeof selectedTime?.dayOffset === "number" && selectedTime.dayOffset > 0) {
			return 1;
		}

		return 0;
	}, [parseDatePart, selectedDate, selectedTime?.dayOffset]);

	const formatDatePartToDDMMYYYY = useCallback((datePart) => {
		const parsedDate = parseDatePart(datePart);
		return parsedDate ? formatDateToDDMMYYYY(parsedDate) : null;
	}, [parseDatePart]);

	const addDaysToDateStr = useCallback((dateStr, days) => {
		const parsedDate = parseDatePart(dateStr);
		if (!parsedDate) return null;
		const nextDate = new Date(parsedDate);
		nextDate.setDate(nextDate.getDate() + Number(days || 0));
		return formatDateToDDMMYYYY(nextDate);
	}, [parseDatePart]);

	const applyCalendarExpansionToPayloadItems = useCallback((payload) => {
		const rawItems = payload?.items;
		const isArrayType = Array.isArray(rawItems);
		let parsedItems = [];

		if (isArrayType) {
			parsedItems = rawItems;
		} else if (typeof rawItems === "string" && rawItems.trim()) {
			try {
				const parsed = JSON.parse(rawItems);
				parsedItems = Array.isArray(parsed) ? parsed : [];
			} catch {
				parsedItems = [];
			}
		}

		if (!Array.isArray(parsedItems) || parsedItems.length === 0) {
			return payload;
		}

		const expandedItems = parsedItems.map((item) => {
			const explicitItemFlag = item?.is_calendar_expansion;
			const hasExplicitFlag =
				explicitItemFlag === 0 ||
				explicitItemFlag === 1 ||
				explicitItemFlag === "0" ||
				explicitItemFlag === "1";

			const normalizedItem = {
				...item,
				is_calendar_expansion: hasExplicitFlag
					? Number(explicitItemFlag)
					: getItemCalendarExpansionFlag(item),
			};

			const startMinutes = convertToMinutes(normalizedItem?.start_time);
			const endMinutes = convertToMinutes(normalizedItem?.end_time);
			const actualDate =
				formatDatePartToDDMMYYYY(normalizedItem?.end_date) ||
				formatDatePartToDDMMYYYY(normalizedItem?.start_date) ||
				(typeof normalizedItem?.service_at === "string"
					? formatDatePartToDDMMYYYY(normalizedItem.service_at.split(" ")[0])
					: null);
			const coveredDate = actualDate ? addDaysToDateStr(actualDate, -1) : null;
			const isEarlyMorningBoundarySplit =
				!!actualDate &&
				!!coveredDate &&
				!Number.isNaN(startMinutes) &&
				!Number.isNaN(endMinutes) &&
				startMinutes >= 0 &&
				startMinutes < 6 * 60 &&
				endMinutes > 6 * 60;

			if (isEarlyMorningBoundarySplit) {
				return {
					...normalizedItem,
					start_date: actualDate,
					end_date: actualDate,
					cross_day_booking_item: null,
					is_calendar_expansion: 0,
				};
			}

			return normalizedItem;
		});

		const crossDayBooking = expandedItems.some((item) =>
			(item?.start_date && item?.end_date && item.start_date !== item.end_date) ||
			(Array.isArray(item?.cross_day_booking_item) && item.cross_day_booking_item.length > 0)
		) ? 1 : (payload?.cross_day_booking ?? 0);

		return {
			...payload,
			cross_day_booking: crossDayBooking,
			items: isArrayType ? expandedItems : JSON.stringify(expandedItems),
		};
	}, [addDaysToDateStr, formatDatePartToDDMMYYYY, getItemCalendarExpansionFlag]);

	// const [sourceSelected, setSourceSelected] = useState(false);
	const [formResetKey, setFormResetKey] = useState(Date.now());
	const [customerError, setCustomerError] = useState("");
	const [serviceError, setServiceError] = useState("");
	const [sourceError, setSourceError] = useState("");
	const [currentStep, setCurrentStep] = useState("summary");
	const currentStepRef = useRef(currentStep);
	const [showCancelWithRefundPopup, setShowCancelWithRefundPopup] = useState(false);
	const [showRepeatPopup, setShowRepeatPopup] = useState(false);
	const [isConfirmedAgainPopupActive, setIsConfirmedAgainPopupActive] = useState(false);
	const [isDiscardPaymentPopupActive, setIsDiscardPaymentPopupActive] = useState(false);
	const [buttonDisabled, setButtonDisabled] = useState(false);
	const [overlappingErrors, setOverlappingErrors] = useState([]);
	const [isSubmitting, setIsSubmitting] = useState(false);
	const [apiErrorForCreateBooking, setApiErrorForCreateBooking] = useState("");
	const [therapistSelectionError, setTherapistSelectionError] = useState("");
	const [roomConflictErrors, setRoomConflictErrors] = useState([]);
	const [isSaleNotePopupActive, setIsSaleNotePopupActive] = useState(false);
	const [saleNote, setSaleNote] = useState("");
	const [isProcessingSaleNote, setIsProcessingSaleNote] = useState(false);
	const [saleNoteError, setSaleNoteError] = useState("");
	const [isVoidSalePopupActive, setIsVoidSalePopupActive] = useState(false);
	const [isCheckoutTopupOpen, setIsCheckoutTopupOpen] = useState(false);
	const [checkoutMembershipFlowType, setCheckoutMembershipFlowType] = useState("topup");
	const [checkoutTopupRefreshKey, setCheckoutTopupRefreshKey] = useState(0);
	const [checkoutRecoveryMembershipSale, setCheckoutRecoveryMembershipSale] = useState(null);
	const [cancelPopupBookingStatus, setCancelPopupBookingStatus] = useState("");
	const [cancelPopupBookingDeposit, setCancelPopupBookingDeposit] = useState(null);
	const lastCancelPopupBookingIdRef = useRef(selectedBookingId);
	const [othersMembershipClient, setOthersMembershipClient] = useState(null);
	const [checkoutTopupCustomer, setCheckoutTopupCustomer] = useState(null);
	const [isOthersMemberTopupFlow, setIsOthersMemberTopupFlow] = useState(false);
	const [completedBookingCanEdit, setCompletedBookingCanEdit] = useState(false);
	const [isCompletedBookingEditProcessing, setIsCompletedBookingEditProcessing] = useState(false);
	useEffect(() => {
		currentStepRef.current = currentStep;
		setIsDiscardPaymentPopupActive(false);
	}, [currentStep]);
	const therapistDisplayName = `${selectedTherapistFromRow?.alias || selectedTherapistFromRow?.name || ""}`.trim();
	const hasRenderableSidebarContent = Boolean(
		bookingDetails ||
		(isEditBookingActive && editableBooking) ||
		newBookingActive ||
		isSidebarLoading ||
		bookingId ||
		selectedBookingId ||
		createdBooking
	);
	const shouldRenderRightSidebar = Boolean(show && hasRenderableSidebarContent);
	const shouldRenderWrapper = shouldRenderRightSidebar || isCheckoutTopupOpen;

		const resolveTopupUserId = useCallback(() => {
			const targetUserId =
				checkoutTopupTargetCustomerRef.current?.user_id ??
				checkoutTopupCustomer?.id;
			if (targetUserId != null && targetUserId !== "") {
				return targetUserId;
			}

			const rawCustomer = itemData?.customer;
			const customerIdFromItem =
				typeof rawCustomer === "object" && rawCustomer != null
					? rawCustomer.id
					: rawCustomer;

			return (
				customerData?.id ??
				bookingDetails?.user?.id ??
				bookingDetails?.user_id ??
				customerIdFromItem ??
				itemData?.customer_id ??
				itemData?.user_id ??
				null
			);
		}, [bookingDetails, checkoutTopupCustomer?.id, customerData, itemData]);

		const buildTopupCheckoutCustomer = useCallback(() => {
			const targetClient = checkoutTopupTargetCustomerRef.current;
			const targetCustomer = membershipClientToTopupCustomer(targetClient);
			if (targetCustomer) {
				return enrichCustomerWithCheckoutPasswordFlag(targetCustomer);
			}

			const userId = resolveTopupUserId();
			if (bookingDetails?.user) {
				return enrichCustomerWithCheckoutPasswordFlag(bookingDetails.user);
			}
			if (customerData?.id) {
				return enrichCustomerWithCheckoutPasswordFlag(customerData);
			}
			if (!userId) {
				return enrichCustomerWithCheckoutPasswordFlag(null);
			}

			return enrichCustomerWithCheckoutPasswordFlag({
				id: userId,
				name:
					bookingDetails?.user_name ??
					itemData?.customer_name ??
					itemData?.customer?.name ??
					customerData?.name ??
					"",
				contact_number:
					bookingDetails?.contact_number ??
					bookingDetails?.user_number ??
					itemData?.contact_number ??
					customerData?.contact_number ??
					"",
				email:
					bookingDetails?.user_email ??
					itemData?.customer?.email ??
					customerData?.email ??
					"",
			});
		}, [bookingDetails, customerData, itemData, resolveTopupUserId]);

	const openCheckoutMembershipFlow = async (flowType = "topup", membershipClient = null) => {
		checkoutTopupTargetCustomerRef.current = membershipClient || null;
		setIsOthersMemberTopupFlow(Boolean(membershipClient?.user_id));
		const mappedTopupCustomer = membershipClient
			? enrichCustomerWithCheckoutPasswordFlag(
					membershipClientToTopupCustomer(membershipClient)
			  )
			: null;
		setCheckoutTopupCustomer(mappedTopupCustomer);

		if (!isCheckoutTopupOpen) {
			checkoutPaymentMethodBeforeTopupRef.current = {
				method: currentPaymentMethod,
				id: currentPaymentMethodId,
			};
			checkoutAmountsBeforeTopupRef.current = {
				amountDue: amountDue,
				amountToCharge: amountToCharge,
			};
		}
		setCheckoutMembershipFlowType(flowType);
		const userId =
			membershipClient?.user_id ??
			mappedTopupCustomer?.id ??
			resolveTopupUserId();
		if (userId) {
			await fetchAndStoreCheckoutCustomerPasswordFlag(userId);
		}
		if (isCheckoutTopupOpen) {
			setIsCheckoutTopupOpen(false);
			window.setTimeout(() => setIsCheckoutTopupOpen(true), 0);
			return;
		}
		setIsCheckoutTopupOpen(true);
	};

	const openMembershipSaleRecovery = useCallback((sale, membershipClient = null) => {
		const { transactionId, membershipId } = getOpenMembershipRecoveryIds(sale);
		if (!transactionId || !membershipId) {
			toast.error("Could not find the open membership sale.");
			return;
		}
		if (!isCheckoutTopupOpen) {
			checkoutPaymentMethodBeforeTopupRef.current = {
				method: currentPaymentMethod,
				id: currentPaymentMethodId,
			};
			checkoutAmountsBeforeTopupRef.current = {
				amountDue: amountDue,
				amountToCharge: amountToCharge,
			};
		}
		if (membershipClient?.user_id) {
			// Others Membership — use the selected client, not the booking customer
			checkoutTopupTargetCustomerRef.current = membershipClient;
			setIsOthersMemberTopupFlow(true);
			const mappedCustomer = enrichCustomerWithCheckoutPasswordFlag(
				membershipClientToTopupCustomer(membershipClient)
			);
			setCheckoutTopupCustomer(mappedCustomer);
		} else {
			checkoutTopupTargetCustomerRef.current = null;
			setIsOthersMemberTopupFlow(false);
			setCheckoutTopupCustomer(buildTopupCheckoutCustomer());
		}
		setCheckoutMembershipFlowType("topup");
		setCheckoutRecoveryMembershipSale(sale);
		setIsCheckoutTopupOpen(true);
	}, [amountDue, amountToCharge, buildTopupCheckoutCustomer, currentPaymentMethod, currentPaymentMethodId, isCheckoutTopupOpen]);

	const restoreCheckoutPaymentMethodAfterTopup = useCallback(() => {
		const { method, id, title } = checkoutPaymentMethodBeforeTopupRef.current;
		setCurrentPaymentMethod(method || "");
		setCurrentPaymentMethodTitle(title || "");
		setCurrentPaymentMethodId(id ?? null);
	}, [setCurrentPaymentMethod, setCurrentPaymentMethodId, setCurrentPaymentMethodTitle]);
	
	const handleCheckoutTopupPaymentSuccess = useCallback(async (detail) => {
			setCheckoutTopupRefreshKey((prev) => prev + 1);
			const topupTargetClient = checkoutTopupTargetCustomerRef.current;
			const topupUserId = resolveTopupUserId();
			if (topupTargetClient?.user_id) {
				const patch = await fetchMembershipClientCreditPatch(topupUserId);
				if (patch) {
					setOthersMembershipClient((previous) => ({
						...(previous || topupTargetClient),
						...patch,
					}));
				}
			} else {
				await refreshCustomerCreditDetailsFromUser(topupUserId, setCustomerCreditDetails);
			}
			if (detail && detail.restoreCheckoutTotals === false) {
				return;
			}
			restoreCheckoutPaymentMethodAfterTopup();
			const restorePreservedCheckoutAmounts = () => {
				const preservedDue = parseFloat(checkoutAmountsBeforeTopupRef.current.amountDue);
				if (!Number.isFinite(preservedDue) || preservedDue < 0) return;
				setAmountDue(preservedDue.toFixed(2));
				const preservedCharge = parseFloat(
					checkoutAmountsBeforeTopupRef.current.amountToCharge
				);
				if (Number.isFinite(preservedCharge) && preservedCharge > 0) {
					setAmountToCharge(Math.min(preservedCharge, preservedDue).toFixed(2));
				}
			};
			if (!selectedBookingId) {
				restorePreservedCheckoutAmounts();
				return;
			}
			try {
				const payloadItems = Array.isArray(discountItemToPost) ? discountItemToPost : [];
				const response = await postApplyDiscountToBooking(selectedBookingId, { items: payloadItems });
				const apiData = response?.data?.data || response?.data || {};
				const subtotal = Number(apiData?.sub_total ?? apiData?.subtotal ?? paymentSummary?.subtotal ?? 0);
				const gst = Number(apiData?.gst_amount ?? apiData?.gst ?? 0);
				const total = Number(apiData?.grand_total ?? apiData?.total ?? (subtotal + gst));
				setServiceTotal(subtotal);
				setPaymentSummary((prev) => ({
					...prev,
					subtotal,
					midtotal: total,
					gst,
					total: total.toFixed(2),
				}));
				const remainingDue = computeRemainingCheckoutAmount(
					total,
					paymentHistory,
					checkoutAmountsBeforeTopupRef.current.amountDue
				);
				const remainingDueStr = remainingDue.toFixed(2);
				setAmountDue(remainingDueStr);
				const preservedCharge = parseFloat(
					checkoutAmountsBeforeTopupRef.current.amountToCharge
				);
				const chargeAmount =
					Number.isFinite(preservedCharge) && preservedCharge > 0
						? Math.min(preservedCharge, remainingDue)
						: remainingDue;
				setAmountToCharge(chargeAmount.toFixed(2));
			} catch (error) {
				console.error("Failed to refresh booking totals after top-up payment:", error);
				restorePreservedCheckoutAmounts();
			}
		}, [
			selectedBookingId,
			discountItemToPost,
			paymentSummary?.subtotal,
			paymentHistory,
			setServiceTotal,
			setPaymentSummary,
			setAmountDue,
			setAmountToCharge,
			restoreCheckoutPaymentMethodAfterTopup,
			setCustomerCreditDetails,
			setOthersMembershipClient,
		]);

	// toast 
	const bookingCreatedToast = () => toast.success("Booking Created Successfully!");
	const paymentSuccessToast = () => toast.success("Payment Success!");
	const refundSuccessToast = () => toast.success("Refund Request Send Successfully!");
	const bookingCancelledToast = () => toast.success("Booking Cancelled Successfully!");
	const bookingDeletedToast = () => toast.success("Booking Deleted Successfully!");
	const bookingNoShowToast = () => toast.success("Booking No-Show Successfully!");
	

		// GET GUEST CHECKIN LIST START (debounced search + paginated infinite scroll)
		const fetchGuestCheckinListPage = useCallback(async ({ page = 1, search = "", append = false } = {}) => {
			if (append) {
				if (guestCheckinAppendInFlightRef.current) return;
				guestCheckinAppendInFlightRef.current = true;
			}
			const reqId = ++guestCheckinListRequestIdRef.current;
			const normalizedSearch = (search || "").trim();
			lastGuestCheckinSearchRef.current = normalizedSearch;

			const baseServiceDateStr = formatDateToDDMMYYYY(selectedDate);
			const extendedDayOffset = getTimeSelectionDayOffset(selectedTime);
			const serviceAtDateStr =
				baseServiceDateStr && extendedDayOffset > 0
					? addDaysToDateStr(baseServiceDateStr, extendedDayOffset) || baseServiceDateStr
					: baseServiceDateStr;

			const params = {
				pagination: 1,
				page,
				outlet: selectedOutlet,
				search_text: normalizedSearch,
				...(selectedDate ? {
					service_at: `${serviceAtDateStr} ${selectedTime?.value || ""}`,
				} : {}),
			};

			if (append) {
				setGuestCheckinLoadingMore(true);
			}

			try {
				const response = await getGuestCheckinList(params);
				if (reqId !== guestCheckinListRequestIdRef.current) return;
				if (response?.data?.success) {
					const list = response.data.data.list;
					const users = list?.users ?? [];
					const pagination = list?.pagination ?? null;
					if (append) {
						setGuestCheckinList((prev) => [...prev, ...users]);
					} else {
						setGuestCheckinList(users);
					}
					setGuestCheckinPagination(pagination);
				} else if (!append) {
					console.error("Error fetching guest checkin list:", response);
				}
			} catch (error) {
				if (reqId !== guestCheckinListRequestIdRef.current) return;
				console.error("Error fetching guest checkin list:", error);
			} finally {
				if (append) {
					guestCheckinAppendInFlightRef.current = false;
					setGuestCheckinLoadingMore(false);
				}
			}
		}, [
			selectedDate,
			selectedTime,
			selectedOutlet,
			formatDateToDDMMYYYY,
			getTimeSelectionDayOffset,
			addDaysToDateStr,
			setGuestCheckinList,
		]);

		const scheduleGuestCheckinSearch = useCallback((query) => {
			if (guestCheckinSearchDebounceRef.current) {
				clearTimeout(guestCheckinSearchDebounceRef.current);
			}
			guestCheckinSearchDebounceRef.current = setTimeout(() => {
				guestCheckinSearchDebounceRef.current = null;
				fetchGuestCheckinListPage({ page: 1, search: query, append: false });
			}, 400);
		}, [fetchGuestCheckinListPage]);

		const handleGetGuestCheckinList = useCallback((isOpen, search = "") => {
			if (guestCheckinSearchDebounceRef.current) {
				clearTimeout(guestCheckinSearchDebounceRef.current);
				guestCheckinSearchDebounceRef.current = null;
			}
			if (isOpen) {
				fetchGuestCheckinListPage({ page: 1, search, append: false });
			}
		}, [fetchGuestCheckinListPage]);

		const handleGuestCheckinLoadMore = useCallback(() => {
			const p = guestCheckinPagination;
			if (!p || guestCheckinLoadingMore) return;
			const next = (p.currentPage ?? 0) + 1;
			const last = p.lastPage ?? 1;
			if (next > last) return;
			fetchGuestCheckinListPage({
				page: next,
				search: lastGuestCheckinSearchRef.current,
				append: true,
			});
		}, [guestCheckinPagination, guestCheckinLoadingMore, fetchGuestCheckinListPage]);

		const guestCheckinHasMore =
			guestCheckinPagination != null &&
			guestCheckinPagination.currentPage < guestCheckinPagination.lastPage;

		useEffect(() => {
			return () => {
				if (guestCheckinSearchDebounceRef.current) {
					clearTimeout(guestCheckinSearchDebounceRef.current);
				}
			};
		}, []);
		// GET GUEST CHECKIN LIST END

		// HANDLE SELECT GUEST CHECKIN START
		// key: 'customer' for customer tag, or pax.id (e.g., 'P1', 'P2') for pax tags
		const handleSelectGuestCheckin = (user, key = 'customer') => {
			if (user) {
				setSelectedGuestCheckin((prev) => ({
					...prev,
					[key]: { item: user }
				}));
			} else {
				setSelectedGuestCheckin((prev) => ({
					...prev,
					[key]: { item: null, cleared: true }
				}));
			}
		};
		// HANDLE SELECT GUEST CHECKIN END

		// GET SELECTED GUEST CHECKIN FOR A SPECIFIC KEY
		const getSelectedGuestCheckin = (key = 'customer') => {
			return selectedGuestCheckin[key] || null;
		};

		useEffect(() => {
			if (shouldRenderWrapper) {
			  document.body.classList.add("rightsidebar-open");
			  setRightSidebarOpen(true);
			} else {
			  document.body.classList.remove("rightsidebar-open");
			  setRightSidebarOpen(false);
			}
			return () => {
			  document.body.classList.remove("rightsidebar-open");
			};
		}, [shouldRenderWrapper, setRightSidebarOpen]);


		useEffect(() => {
			if (!shouldRenderRightSidebar) return;
			const isMainContentInteraction = (event) => {
				const container = mainContentRef?.current;
				if (!container) return false;
				if (container.contains(event.target)) return true;
				if (event.target.closest?.(".prevent-outside-click")) return true;
				// Scrollbar thumb/track clicks can fall outside contains() in some browsers.
				const rect = container.getBoundingClientRect();
				const { clientX: x, clientY: y } = event;
				if (x < rect.left || x > rect.right || y < rect.top || y > rect.bottom) {
					return false;
				}
				const verticalScrollbarGutter = container.offsetWidth - container.clientWidth;
				const horizontalScrollbarGutter = container.offsetHeight - container.clientHeight;
				if (verticalScrollbarGutter > 0 && x >= rect.right - verticalScrollbarGutter) {
					return true;
				}
				if (horizontalScrollbarGutter > 0 && y >= rect.bottom - horizontalScrollbarGutter) {
					return true;
				}
				return false;
			};

			const handleClickOutside = (event) => {
				if (isMainContentInteraction(event)) {
					return;
				}
				if (
					sidebarRef.current &&
					!sidebarRef.current.contains(event.target)
				) {
					const isCreatingNewBooking = newBookingActive || (!selectedBookingId && newAppointmentSlots.length > 0);
					if (isCreatingNewBooking) {
						return;
					}
					if (isCheckoutTopupOpen) {
						return;
					}
					// Don't close sidebar when clicking inside a portal-rendered modal
					// (CancelBookingPopup, DiscardPaymentPopup, ConfirmedAgainPopup, etc.)
					if (event.target.closest?.('.customModalOverlay')) {
						return;
					}
					// When editing a booking, show the discard confirmation popup
					// instead of immediately closing the sidebar
					if (isEditBookingActive || currentStepRef.current === "editBooking") {
						event.preventDefault();
						event.stopPropagation();
						if (typeof event.stopImmediatePropagation === "function") {
							event.stopImmediatePropagation();
						}
						setShowConflictModal(true);
						return;
					}
					event.preventDefault();
					event.stopPropagation();
					if (typeof event.stopImmediatePropagation === "function") {
						event.stopImmediatePropagation();
					}
					hideSidebar();
				}
			};

			document.addEventListener("mousedown", handleClickOutside, true);

			return () => {
				document.removeEventListener("mousedown", handleClickOutside, true);
			};
		}, [hideSidebar, isCheckoutTopupOpen, isEditBookingActive, mainContentRef, newAppointmentSlots.length, newBookingActive, selectedBookingId, setShowConflictModal, shouldRenderRightSidebar]);


	useEffect(() => {
		if (bookingId || createdBooking) {
			const currentBookingId = bookingId || createdBooking?.id || createdBooking?.booking_id;
			// Reset to "summary" when switching to a different booking
			// Only skip reset if it's the same booking and we're already on "saleinfo" (e.g., after payment)
			if (currentBookingId !== lastResetBookingIdRef.current) {
				setCurrentStep("summary");
				lastResetBookingIdRef.current = currentBookingId;
			} else if (currentStep === "saleinfo") {
				// Same booking but on "saleinfo" - don't reset (payment success case)
				return;
			}
		} else {
			// No booking selected - reset the ref
			lastResetBookingIdRef.current = null;
		}
	}, [bookingId, createdBooking, currentStep]);
		// Auto-open Edit view once when a drag-drop prefill is provided
		const hasAppliedPrefillRef = useRef(false);
		const lastPrefillSigRef = useRef(null);
		useEffect(() => {
			// Cancel/clear must reset these refs so a later drop to the same Y/time
			// can reopen editBooking (same prefill signature is intentional).
			if (!editPrefill) {
				hasAppliedPrefillRef.current = false;
				lastPrefillSigRef.current = null;
				return;
			}
			const sig = `${editPrefill?.bookingId || ''}:${editPrefill?.itemId || ''}:${editPrefill?.startTime || ''}:${editPrefill?.therapistId || ''}`;
			if (lastPrefillSigRef.current !== sig) {
				lastPrefillSigRef.current = sig;
				hasAppliedPrefillRef.current = false;
			}
			if (hasAppliedPrefillRef.current) return;
			// Ensure a booking is selected in context and sidebar is open
			if (show && (bookingId || createdBooking)) {
				// Prefer fetched booking details when available; fallback to list item.
				const selectedFromList = bookingsList.find(
					(b) => Number(b.id) === Number(bookingId)
				);
				const selectedFromDetails =
					bookingDetails && Number(bookingDetails?.id) === Number(bookingId)
						? {
							...bookingDetails,
							booking_item:
								normalizeBookingItems(bookingDetails?.booking_item) ||
								bookingDetails?.booking_item,
						}
						: null;
				const editableSource = selectedFromDetails || selectedFromList;
				if (editableSource) {
					resetActiveEditBookingContext(editableSource?.id);
					setIsEditBookingActive(true);
					setCurrentStep("editBooking");
					setEditableBooking(editableSource);
					hasAppliedPrefillRef.current = true;
				}
			}
		}, [bookingId, bookingsList, bookingDetails, createdBooking, editPrefill, resetActiveEditBookingContext, setIsEditBookingActive, show]);

		// Check for overlapping bookings whenever services, existing bookings, staff timing, or breaks change
		useEffect(() => {
			// Only check for overlaps if we have services to check and we're not in the middle of booking creation
			if ((selectedServices.length > 0 || paxes.length > 0) && !buttonDisabled) {
				checkOverlappingBookings();
			} else if (selectedServices.length === 0 && paxes.length === 0) {
				// Clear overlapping errors when no services are selected
				setOverlappingErrors([]);
			}
		}, [selectedServices, paxes, bookingsList, staffTiming, selectedDate, buttonDisabled, breaksData]);

		// ENHANCED: Scroll to booking form when services are added or updated (including pax services)
		useEffect(() => {
			if (selectedServices.length > 0 || paxes.length > 0) {
				setTimeout(() => {
					const sidebarContent = document.querySelector('.sideBarContent');
					if (sidebarContent) {
						// Find all service cards (both main and pax)
						const allServiceCards = sidebarContent.querySelectorAll('.selectedService');
						
						if (allServiceCards.length > 0) {
							// Get the last service card (latest added)
							const lastServiceElement = allServiceCards[allServiceCards.length - 1];
							
							lastServiceElement.scrollIntoView({
								behavior: 'smooth',
								block: 'center'
							});
						} else {
							// If no service cards found, try to find pax blocks
							// Look for elements that contain paxData class (which is defined in CSS)
							const paxDataElements = sidebarContent.querySelectorAll('[class*="paxData"]');
							
							if (paxDataElements.length > 0) {
								// Get the last pax data element and scroll to its parent (the pax block)
								const lastPaxData = paxDataElements[paxDataElements.length - 1];
								const paxBlock = lastPaxData.closest('div');
								
								if (paxBlock) {
									paxBlock.scrollIntoView({
										behavior: 'smooth',
										block: 'center'
									});
								}
							} else {
								// Try alternative approach - look for elements with guest icon
								const guestElements = sidebarContent.querySelectorAll('img[src*="guest"]');
								
								if (guestElements.length > 0) {
									const lastGuestElement = guestElements[guestElements.length - 1];
									const paxBlock = lastGuestElement.closest('div');
									
									if (paxBlock) {
										paxBlock.scrollIntoView({
											behavior: 'smooth',
											block: 'center'
										});
									}
								}
							}
						}
					}
				}, 500); // Increased delay to ensure DOM is fully updated
			}
		}, [selectedServices, paxes]);

		const validateFields = () => {
			let isValid = true;

			if (!itemData.customer) {
				setCustomerError("Please select a customer.");
				isValid = false;
			}

			if (paxes.length === 0 && selectedServices.length === 0) {
				setServiceError("Please select at least one service.");
				isValid = false;
			}

			if (!itemData.source) {
				setSourceError("Please select a source.");
				isValid = false;
			}

			// Check for overlapping bookings
			const allServices = getAllDraftServices();

			if (allServices.some((service) => getServiceTherapistId(service) == null)) {
				setTherapistSelectionError("Please select therapist for all services");
				isValid = false;
			}

			const overlappingServices = allServices?.filter((service) => {
				const serviceTherapistId = getServiceTherapistId(service);
				if (!serviceTherapistId || !service?.start_time || !service?.end_time) return false;
				
				// Check if this service overlaps with any other service for the same therapistk
				return allServices.some((otherService) => {
					if (otherService?.counterKey === service?.counterKey) return false;
					const otherServiceTherapistId = getServiceTherapistId(otherService);
					if (!otherServiceTherapistId || !otherService?.start_time || !otherService?.end_time) return false;
					
					// Only check for overlaps if it's the same therapist
					if (serviceTherapistId !== otherServiceTherapistId) return false;

					const s1 = convertToMinutes(service?.start_time);
					const e1 = convertToMinutes(service?.end_time);
					const s2 = convertToMinutes(otherService?.start_time);
					const e2 = convertToMinutes(otherService?.end_time);

					return !(e1 <= s2 || s1 >= e2); // overlapping
				});
			});

			// Note: Overlapping services validation is now handled by the API
			// We allow the booking to proceed and let the backend handle conflicts
			// if (overlappingServices?.length > 0) {
			//	setServiceError("Some services have overlapping times with the same therapist.");
			//	isValid = false;
			// }

			return isValid;
		};

		// Check for overlapping bookings with therapist schedules
		const checkOverlappingBookings = () => {
			const allServices = getAllDraftServices();

			// Don't check when there are no services
			if (allServices.length === 0) {
				return [];
			}

			const errors = [];
			const therapistErrorIndexMap = new Map(); // Map therapistId -> index in errors for updates

			// Consider only active bookings for overlap comparison to avoid false positives
			const isActiveBookingStatus = (statusRaw) => {
				const s = (statusRaw || "").toString().toLowerCase();
				return (
					s === "confirmed" ||
					s === "checked-in" ||
					s === "check-in (in progress)" ||
					s === "check-in"
				);
			};
			
			// Helper function to robustly parse time strings and convert to minutes
			const parseTimeToMinutes = (timeString) => {
				if (!timeString) return null;
				
				// Handle different time formats
				if (typeof timeString === 'string') {
					// Remove any date part if present (e.g., "2025-09-03T14:30:00" -> "14:30:00")
					let timeOnly = timeString;
					
					// Handle ISO format: "2025-09-03T14:30:00"
					if (timeString.includes('T')) {
						timeOnly = timeString.split('T')[1];
					}
					// Handle space-separated format: "2025-09-03 14:30:00"
					else if (timeString.includes(' ')) {
						timeOnly = timeString.split(' ')[1];
					}
					// Handle dash-separated format: "03-09-2025 14:30:00"
					else if (timeString.includes('-') && timeString.includes(':')) {
						const parts = timeString.split(' ');
						if (parts.length > 1) {
							timeOnly = parts[1];
						}
					}
					
					// Clean up time format (remove seconds if present, keep only HH:MM)
					const timeParts = timeOnly.split(':');
					if (timeParts.length >= 2) {
						const hours = parseInt(timeParts[0], 10);
						const minutes = parseInt(timeParts[1], 10);
						
						if (!isNaN(hours) && !isNaN(minutes)) {
							return hours * 60 + minutes;
						}
					}
				}
				
				// If it's already a number (minutes), return as is
				if (typeof timeString === 'number' && !isNaN(timeString)) {
					return timeString;
				}
				
				return null;
			};
			
			// Helper function to get service duration with fallbacks
			const getServiceDuration = (service, defaultDuration = 30) => {
				// Try to get duration from various possible fields
				let duration = service.duration || service.service_duration || service.length || 0;
				
				// If duration is missing, 0, or invalid, try to calculate from start/end times
				if (!duration || duration <= 0) {
					if (service.start_time && service.end_time) {
						const startMinutes = convertToMinutes(service.start_time);
						const endMinutes = convertToMinutes(service.end_time);
						if (startMinutes !== null && endMinutes !== null && endMinutes > startMinutes) {
							duration = endMinutes - startMinutes;
						}
					}
				}
				
				// If still no valid duration, use default
				if (!duration || duration <= 0) {
					duration = defaultDuration;
				}
				
				return duration;
			};
			
			allServices.forEach((service) => {
				// Check if service has all required properties and valid time data
				const normalizedServiceTherapistId = getServiceTherapistId(service);
				if (normalizedServiceTherapistId && service.start_time && service.end_time) {
					// Validate that start and end times are actually valid
					const startMinutes = convertToMinutes(service.start_time);
					const endMinutes = convertToMinutes(service.end_time);
					if (startMinutes === null || endMinutes === null || isNaN(startMinutes) || isNaN(endMinutes) || startMinutes >= endMinutes) {
						return; // Skip invalid time data
					}
					
					// Check if this service overlaps with any other service for the same therapist (within current booking)
					const isOverlappingWithCurrentBooking = allServices.some((otherService) => {
						if (otherService.counterKey === service.counterKey) return false;
						if (!otherService?.start_time || !otherService?.end_time) return false;
						
						// Validate other service time data
						const otherStartMinutes = convertToMinutes(otherService.start_time);
						const otherEndMinutes = convertToMinutes(otherService.end_time);
						if (otherStartMinutes === null || otherEndMinutes === null || isNaN(otherStartMinutes) || isNaN(otherEndMinutes)) {
							return false; // Skip invalid time data
						}
						
						// Normalize and compare therapist IDs
						const normalizedOtherTherapistId = getServiceTherapistId(otherService);
						if (normalizedServiceTherapistId !== normalizedOtherTherapistId) return false;
						
						// Skip overlap check if either therapist is null/auto-assigned
						if (!normalizedServiceTherapistId || !normalizedOtherTherapistId) return false;
						
						if (!otherService.start_time || !otherService.end_time) return false;

						const s1 = convertToMinutes(service.start_time);
						const e1 = convertToMinutes(service.end_time);
						const s2 = convertToMinutes(otherService.start_time);
						const e2 = convertToMinutes(otherService.end_time);

						return !(e1 <= s2 || s1 >= e2); // overlapping
					});

					// Check if this service overlaps with existing bookings from API
					const isOverlappingWithExistingBookings = bookingsList?.some((existingBooking) => {
						// Check if the existing booking has the same therapist
						// Try multiple possible therapist ID fields including booking_item
						let existingTherapistId = existingBooking.therapist_id || existingBooking.therapist || existingBooking.staff_id;
						
						// If not found at top level, check booking_item structure
						if (!existingTherapistId && existingBooking.booking_item) {
							// booking_item might be an object with customer names as keys
							const bookingItems = existingBooking.booking_item;
							
							// Check each customer's services in booking_item
							for (const [customerName, services] of Object.entries(bookingItems)) {
								if (Array.isArray(services)) {
									for (const service of services) {
										existingTherapistId = service.therapist_id || service.therapist || service.staff_id;
										if (existingTherapistId) {
											break;
										}
									}
								}
								if (existingTherapistId) break;
							}
						}
						
						// Normalize and compare therapist IDs
						const normalizedExistingTherapistId = normalizeComparableId(existingTherapistId);
						if (normalizedExistingTherapistId !== normalizedServiceTherapistId) return false;
						
						// Parse existing booking time - try multiple possible formats
						let existingServiceAt = existingBooking.service_at || existingBooking.start_time || existingBooking.time;
						let duration = getServiceDuration(existingBooking, 30); // Use helper function with 30 min default
						// Skip bookings that are not active (cancelled, completed, holding etc.)
						if (!isActiveBookingStatus(existingBooking?.status)) return false;
						
						// If not found at top level, check booking_item structure for time
						if (!existingServiceAt && existingBooking.booking_item) {
							const bookingItems = existingBooking.booking_item;
							
							// Check each customer's services in booking_item for time
							for (const [customerName, services] of Object.entries(bookingItems)) {
								if (Array.isArray(services)) {
									for (const service of services) {
										existingServiceAt = service.service_at || service.start_time || service.time;
										// Get duration from this specific service if available
										const serviceDuration = getServiceDuration(service, duration);
										if (existingServiceAt) {
											duration = serviceDuration;
											break;
										}
									}
								}
								if (existingServiceAt) break;
							}
						}
						
						if (!existingServiceAt) return false;
						
						// Use robust time parsing
						const existingStartMinutes = parseTimeToMinutes(existingServiceAt);
						if (existingStartMinutes === null) return false;
						
						// Calculate end time
						const existingEndMinutes = existingStartMinutes + duration;
						
						// Convert current service time to minutes
						const currentStartMinutes = convertToMinutes(service.start_time);
						const currentEndMinutes = convertToMinutes(service.end_time);
						if (currentStartMinutes === null || currentEndMinutes === null || isNaN(currentStartMinutes) || isNaN(currentEndMinutes)) {
							return false;
						}
						
						// Check for overlap
						return !(currentEndMinutes <= existingStartMinutes || currentStartMinutes >= existingEndMinutes);
					});

					// Check if service overlaps with any break for the same therapist
					const isOverlappingWithBreaks = breaksData?.some((breakItem) => {
						// Check if break is for the same therapist
						const breakTherapistId = String(breakItem.therapist_id);
						if (breakTherapistId !== normalizedServiceTherapistId) return false;
						
						// Convert break times to minutes
						const breakStartMinutes = convertToMinutes(breakItem.start_time);
						const breakEndMinutes = convertToMinutes(breakItem.end_time);
						
						if (breakStartMinutes === null || breakEndMinutes === null) return false;
						
						// Convert service times to minutes
						const serviceStartMinutes = convertToMinutes(service.start_time);
						const serviceEndMinutes = convertToMinutes(service.end_time);
						
						if (serviceStartMinutes === null || serviceEndMinutes === null) return false;
						
						// Check for overlap
						return !(serviceEndMinutes <= breakStartMinutes || serviceStartMinutes >= breakEndMinutes);
					});

					// Availability/working-hours messaging is handled by isGreyBox.
					// Keep overlappingErrors focused on true overlap/break conflicts only.
					if (isOverlappingWithCurrentBooking || isOverlappingWithExistingBookings || isOverlappingWithBreaks) {
						// Find therapist name from homeStaffList - try both string and number comparison
						
						const therapist = homeStaffList.find(staff => 
							normalizeComparableId(staff.id) === normalizedServiceTherapistId ||
							staff.name === normalizedServiceTherapistId
						);
						const therapistName = therapist?.alias || therapist?.name;
						
						// Update existing therapist error entry, or add a new one
						const existingErrorIndex = therapistErrorIndexMap.get(normalizedServiceTherapistId);
						if (existingErrorIndex !== undefined) {
							errors[existingErrorIndex].isOverlappingWithBreaks =
								Boolean(errors[existingErrorIndex].isOverlappingWithBreaks) || Boolean(isOverlappingWithBreaks);
						} else {
							therapistErrorIndexMap.set(normalizedServiceTherapistId, errors.length);
							errors.push({
								therapistId: normalizedServiceTherapistId,
								therapistName,
								serviceName: service.name,
								startTime: service.start_time,
								endTime: service.end_time,
								isOverlappingWithBreaks: isOverlappingWithBreaks
							});
						}
					}
				}
			});

			//  ADDED: Check for same customer time overlap with different therapists
			const customerTimeOverlaps = [];
			const processedCustomerOverlaps = new Set();
			
			// Check overlaps within main customer services (selectedServices)
			if (selectedServices.length > 1) {
				const customerOverlapGroups = new Set();
				
				selectedServices.forEach((service) => {
					if (!service.start_time || !service.end_time) return;
					
					// Find all services that overlap with this service and have different therapists
					const overlappingServices = selectedServices.filter((otherService) => {
						if (otherService.counterKey === service.counterKey) return false;
						if (!otherService.start_time || !otherService.end_time) return false;
						
						// Normalize therapist IDs
						const normalizedServiceTherapistId = getServiceTherapistId(service);
						const normalizedOtherTherapistId = getServiceTherapistId(otherService);
						
						// Only check if therapists are different (and both are not null/auto-assign)
						if (!normalizedServiceTherapistId || !normalizedOtherTherapistId || 
							normalizedServiceTherapistId === normalizedOtherTherapistId) return false;
						
						// Check for time overlap
						const s1 = convertToMinutes(service.start_time);
						const e1 = convertToMinutes(service.end_time);
						const s2 = convertToMinutes(otherService.start_time);
						const e2 = convertToMinutes(otherService.end_time);
						
						return !(e1 <= s2 || s1 >= e2); // overlapping
					});
					
					if (overlappingServices.length > 0) {
						// Create a unique key for this overlap group (sorted to ensure consistency)
						const overlapKeys = [service.counterKey, ...overlappingServices.map(s => s.counterKey)].sort();
						const groupKey = `customer-${overlapKeys.join('-')}`;
						
						if (!customerOverlapGroups.has(groupKey)) {
							customerOverlapGroups.add(groupKey);
							customerTimeOverlaps.push({
								therapistName: 'Customer',
								serviceName: 'Multiple services',
								startTime: service.start_time,
								endTime: service.end_time,
								isCustomerTimeOverlap: true
							});
						}
					}
				});
			}
			
			// Check overlaps within each pax's services separately
			paxes.forEach((pax) => {
				if (!pax.selectedServices || pax.selectedServices.length <= 1) return;
				
				const paxOverlapGroups = new Set();
				
				pax.selectedServices.forEach((service) => {
					if (!service.start_time || !service.end_time) return;
					
					// Find all services that overlap with this service and have different therapists
					const overlappingServices = pax.selectedServices.filter((otherService) => {
						if (otherService.counterKey === service.counterKey) return false;
						if (!otherService.start_time || !otherService.end_time) return false;
						
						// Normalize therapist IDs
						const normalizedServiceTherapistId = getServiceTherapistId(service);
						const normalizedOtherTherapistId = getServiceTherapistId(otherService);
						
						// Only check if therapists are different (and both are not null/auto-assign)
						if (!normalizedServiceTherapistId || !normalizedOtherTherapistId || 
							normalizedServiceTherapistId === normalizedOtherTherapistId) return false;
						
						// Check for time overlap
						const s1 = convertToMinutes(service.start_time);
						const e1 = convertToMinutes(service.end_time);
						const s2 = convertToMinutes(otherService.start_time);
						const e2 = convertToMinutes(otherService.end_time);
						
						return !(e1 <= s2 || s1 >= e2); // overlapping
					});
					
					if (overlappingServices.length > 0) {
						// Create a unique key for this overlap group (sorted to ensure consistency)
						const overlapKeys = [service.counterKey, ...overlappingServices.map(s => s.counterKey)].sort();
						const groupKey = `pax-${pax.customer_name}-${overlapKeys.join('-')}`;
						
						if (!paxOverlapGroups.has(groupKey)) {
							paxOverlapGroups.add(groupKey);
							customerTimeOverlaps.push({
								therapistName: pax.customer_name || 'Guest',
								serviceName: 'Multiple services',
								startTime: service.start_time,
								endTime: service.end_time,
								isCustomerTimeOverlap: true
							});
						}
					}
				});
			});
			
			// Add customer time overlap errors to the main errors array
			errors.push(...customerTimeOverlaps);

			setOverlappingErrors(errors);
			return errors;
		};


		// Reset function to clear all booking data
		const resetSidebarStateOnCancel = () => {
			resetBookingForm();
			setIsCustomerSelected(false);
			setSelectedServices([]);
			setNewAppointmentSlots([]);
			setNewSlot(null);
			setPaxes([]);
			setFormResetKey(Date.now());
			setCustomerError("");
			setServiceError("");
			setSourceError("");
			setOverlappingErrors([]);
			setRoomConflictErrors([]);
			// Clear all guest check-in tags
			setSelectedGuestCheckin({});
			setCompleteBookingWarning(false);
			setShowPaymentInProgressNotice(false);
			setDeletedBookingItemIds([]);
			setNewBookingActive(false);
			try {
				setDateSyncState({
					requestId: 0,
					mode: null,
					status: "idle",
					date: null,
				});
			} catch {}
		};

		// Corrected resetSidebarState function
		const resetSidebarState = () => {
			resetBookingForm();
			setIsCustomerSelected(false);
			setSelectedServices([]);
			setNewAppointmentSlots([]);
			setNewSlot(null);
			setPaxes([]);
			setFormResetKey(Date.now());
			setCustomerError("");
			setServiceError("");
			setSourceError("");
			setOverlappingErrors([]);
			setRoomConflictErrors([]);
			// Clear all guest check-in tags
			setSelectedGuestCheckin({});
			setCompleteBookingWarning(false);
			setShowPaymentInProgressNotice(false);
			setDeletedBookingItemIds([]);
		};

		function normalizeBookingItems(bookingItem) {
			if (!bookingItem || typeof bookingItem !== 'object') return bookingItem;
			const normalized = {};
			for (const [customerName, items] of Object.entries(bookingItem)) {
				normalized[customerName] = (Array.isArray(items) ? items : []).map((item) => {
					let additionalInfo = {};
					if (item?.additional) {
						if (typeof item.additional === 'object') {
							additionalInfo = item.additional;
						} else {
							try { additionalInfo = JSON.parse(item.additional); } catch { additionalInfo = {}; }
						}
					}
					return {
						...item,
						isDiscountApplied: item.isDiscountApplied ?? additionalInfo.isDiscountApplied,
						isMemberRateApplied: item.isMemberRateApplied ?? additionalInfo.isMemberRateApplied,
						isMembershipApplied: item.isMembershipApplied ?? additionalInfo.isMembershipApplied,
						price_adjustment: item.price_adjustment ?? additionalInfo.price_adjustment ?? null,
						discount_option: item.discount_option,
						price_rate: item.price_rate ?? additionalInfo.price_rate ?? null,
						commission_price_adjustment: item.commission_price_adjustment ?? additionalInfo.commission_price_adjustment ?? null,
						edited_commission: item.edited_commission ?? additionalInfo.edited_commission ?? null,
						maximum_commission_price: item.maximum_commission_price ?? additionalInfo.maximum_commission_price ?? null,
						splited: item.splited ?? additionalInfo.splited,
						commission: item.commission ?? additionalInfo.commission,
						commission_addons: item.commission_addons ?? additionalInfo.commission_addons,
					};
				});
			}
			return normalized;
		}

		const fetchBookingDetails = useCallback(async ({ force = false } = {}) => {
			if (!selectedBookingId) { setSelectedSaleId(null); return null; }
			const requestBookingId = String(selectedBookingId);
			// Same booking already fetching — skip duplicate (drag/open often triggers effect twice).
			// Force (e.g. View Sale) supersedes the in-flight request via requestGen.
			if (!force && bookingDetailsInFlightIdRef.current === requestBookingId) { return null; }
			const requestGen = ++bookingDetailsFetchGenRef.current;
			bookingDetailsInFlightIdRef.current = requestBookingId;
			try {
				setSidebarLoading(true);
				const fetchDateStr =
					bookingDetailsRef.current?.service_date ||
					(selectedDate ? formatDateToDDMMYYYY(selectedDate) : undefined);
				let params = {
					pagination: 1,
					selected_date: fetchDateStr,
					is_calendar_expansion: getOutletExtendedFlagForDate(
						selectedOutletData?.timing,
						fetchDateStr
					) ? 1 : 0,
				};
                const response = await getBookingDetail2(selectedBookingId, params);
				// Ignore stale / closed-sidebar / superseded responses.
				if (requestGen !== bookingDetailsFetchGenRef.current) {
					return null;
				}
				if (String(selectedBookingIdRef.current || "") !== requestBookingId) {
					return null;
				}
				const bookingDataResponse = response?.data?.data?.booking?.bookings?.[0];
				if (!bookingDataResponse) {
					return null;
				}
				const bookingItems = normalizeBookingItems(bookingDataResponse?.booking_item);
				const shouldPreserveCheckoutState = ["checkout", "payment", "confirmation"].includes(currentStepRef.current);
				if (!shouldPreserveCheckoutState) {
					resetCheckoutState();
				}
				const normalizedBookingDataResponse = {
					...bookingDataResponse,
					booking_item: bookingItems || bookingDataResponse?.booking_item,
				};
				if (bookingDataResponse?.id != null) {
					hydratedBookingDetailsIdRef.current = String(bookingDataResponse.id);
				} else if (selectedBookingId != null) {
					hydratedBookingDetailsIdRef.current = String(selectedBookingId);
				}
				setBookingDetails(normalizedBookingDataResponse);
				setCustomerBookingItems(bookingItems);
				setSaleNote(bookingDataResponse?.sales_note || '');
				const sid = bookingDataResponse?.sale_id;
				setSelectedSaleId(sid != null && sid !== "" ? String(sid) : null);

				// Seed discount / member-rate overrides from the fresh API response.
				// Live local overrides (including explicit null = user cleared) win.
				const apiBookingItems = normalizeBookingItems(bookingDataResponse?.booking_item);
				if (apiBookingItems && typeof apiBookingItems === 'object') {
					const { seededDiscounts, seededMemberRates } = buildSeededPricingOverrides(apiBookingItems);
					if (Object.keys(seededDiscounts).length > 0) {
						setDiscountByBookingItemId((prev) => mergePricingOverrideMap(prev, seededDiscounts));
					}
					if (Object.keys(seededMemberRates).length > 0) {
						setMemberRateByBookingItemId((prev) => mergePricingOverrideMap(prev, seededMemberRates));
					}
				}

				return normalizedBookingDataResponse;
			} catch (error) {
				if (requestGen === bookingDetailsFetchGenRef.current) {
					console.error("Error:", error);
				}
				return null;
			} finally {
				// Only the latest request clears in-flight / loading (force View Sale can supersede).
				if (requestGen === bookingDetailsFetchGenRef.current) {
					if (bookingDetailsInFlightIdRef.current === requestBookingId) {
						bookingDetailsInFlightIdRef.current = null;
					}
					setIsBookingInfoUpdated(false);
					setSidebarLoading(false);
				}
			}
		}, [resetCheckoutState, selectedBookingId, selectedDate, selectedOutletData?.timing, setBookingDetails, setCustomerBookingItems, setDiscountByBookingItemId, setMemberRateByBookingItemId, setIsBookingInfoUpdated, setSelectedSaleId, setSidebarLoading]);

		const handleViewSale = useCallback(async () => {
			const details = bookingDetailsRef.current;
			const saleId = details?.sale_id;
			const detailStatus = String(details?.status || "").toLowerCase();
			const hasFreshSale =saleId != null && String(saleId).trim() !== "" && ["completed", "closed", "voided"].includes(detailStatus);

			if (hasFreshSale) {
				setCurrentStep("saleinfo");
				return true;
			}

			const refreshed = await fetchBookingDetails({ force: true });
			const refreshedSaleId = refreshed?.sale_id ?? bookingDetailsRef.current?.sale_id;
			if (refreshedSaleId == null || String(refreshedSaleId).trim() === "") {
				toast.error("Sale details are not available yet. Please try again.");
				return false;
			}
			setCurrentStep("saleinfo");
			return true;
		}, [fetchBookingDetails, setCurrentStep]);


		useEffect(() => {
			if (!selectedBookingId) {
				hydratedBookingDetailsIdRef.current = null;
				// Drop in-flight apply when selection is cleared (sidebar close / switch).
				bookingDetailsFetchGenRef.current += 1;
				bookingDetailsInFlightIdRef.current = null;
				setSidebarLoading(false);
				return;
			}
			// Edit opened from sidebar without drag: seed from list/details already in context.
			if (isEditBookingActive && !editPrefill) return;
			if (skipDetailFetchForIdRef.current === selectedBookingId) {
				skipDetailFetchForIdRef.current = null;
				return;
			}
			// Drag/edit with prefill: do not re-hit booking-details if this booking is already hydrated.
			// Use refs only — do NOT depend on bookingDetails state or this effect loops on every fetch.
			if (isEditBookingActive && editPrefill) {
				const id = String(selectedBookingId);
				const details = bookingDetailsRef.current;
				const alreadyHydrated =
					hydratedBookingDetailsIdRef.current === id ||
					(details &&
						String(details.id) === id &&
						details.booking_item != null);
				if (alreadyHydrated) return;
				// In-flight fetch for this booking — wait for it; do not start a second call.
				if (bookingDetailsInFlightIdRef.current === id) return;
			}
			fetchBookingDetails();
		}, [selectedBookingId, fetchBookingDetails, isEditBookingActive, editPrefill]);
	
		useEffect(() => {
		if (isBookingInfoUpdated) {
			fetchBookingDetails();
		}
		}, [isBookingInfoUpdated, fetchBookingDetails]);		

		useEffect(() => {
			if (!isEditBookingActive || !editPrefill || !bookingDetails?.id) return;
			const targetBookingId = Number(editPrefill?.bookingId || bookingId);
			if (Number(bookingDetails?.id) !== targetBookingId) return;
			const normalizedBookingItems = normalizeBookingItems(bookingDetails?.booking_item);
			setEditableBooking((prev) => {
				if (!prev || Number(prev?.id) !== targetBookingId) return prev;
				return {
					...bookingDetails,
					booking_item: normalizedBookingItems || bookingDetails?.booking_item,
				};
			});
		}, [isEditBookingActive, editPrefill, bookingDetails, bookingId, setEditableBooking]);

		useEffect(() => {
			if (!selectedBookingId) setSelectedSaleId(null);
		}, [selectedBookingId, setSelectedSaleId]);

		useEffect(() => {
			if (lastCancelPopupBookingIdRef.current === selectedBookingId) return;

			lastCancelPopupBookingIdRef.current = selectedBookingId;
			setShowCancelPopup(false);
			setShowCancelWithRefundPopup(false);
			setCancelPopupBookingStatus("");
			setCancelPopupBookingDeposit(null);
			setApiError("");
			setSelectedRemark("");
			setSelectedReason("");
		}, [selectedBookingId, setApiError, setSelectedReason, setSelectedRemark, setShowCancelPopup]);

		useEffect(() => {
			const handleCustomerNotesUpdated = (event) => {
				const updatedCustomerId = event?.detail?.customerId;
				const updatedNotes = event?.detail?.notes ?? "";
				if (!updatedCustomerId) return;

				setBookingDataFromAPI((prev) => ({
					...(prev || {}),
					...(Number(prev?.user_id) === Number(updatedCustomerId)
						? { users_notes: updatedNotes }
						: {}),
				}));

				setBookingDetails((prev) => {
					if (!prev) return prev;
					const customerId = prev?.user?.id ?? prev?.user_id;
					if (Number(customerId) !== Number(updatedCustomerId)) return prev;
					return {...prev,
						users_notes: updatedNotes,
						user: prev?.user
							? {
								...prev.user,
								note: updatedNotes,
								notes: updatedNotes,
							}
							: prev?.user,
					};
				});

				setEditableBooking((prev) => {
					if (!prev) return prev;
					const customerId = prev?.user?.id ?? prev?.user_id;
					if (Number(customerId) !== Number(updatedCustomerId)) return prev;
					return {
						...prev,
						users_notes: updatedNotes,
						user: prev?.user
							? {
								...prev.user,
								note: updatedNotes,
								notes: updatedNotes,
							}
							: prev?.user,
					};
				});

				setCustomerData((prev) => {
					if (!prev || Number(prev?.id) !== Number(updatedCustomerId)) return prev;
					return {
						...prev,
						note: updatedNotes,
						notes: updatedNotes,
						users_notes: updatedNotes,
					};
				});

				setBookingsList((prev) => {
					if (!Array.isArray(prev)) return prev;
					return prev.map((booking) => {
						const bookingCustomerId = booking?.user_id ?? booking?.user?.id;
						if (Number(bookingCustomerId) !== Number(updatedCustomerId)) return booking;
						return {
							...booking,
							users_notes: updatedNotes,
							user: booking?.user
								? {
									...booking.user,
									note: updatedNotes,
									notes: updatedNotes,
								}
								: booking?.user,
						};
					});
				});
			};

			window.addEventListener("customerNotesUpdated", handleCustomerNotesUpdated);
			return () => {
				window.removeEventListener("customerNotesUpdated", handleCustomerNotesUpdated);
			};
		}, [setBookingDataFromAPI, setBookingDetails, setEditableBooking, setCustomerData, setBookingsList]);

		useEffect(() => {
			const handleCustomerUpdated = (event) => {
				const updatedCustomer = event?.detail?.customer;
				if (!updatedCustomer?.id) return;
				const latestNotes =updatedCustomer?.note ??updatedCustomer?.notes ??updatedCustomer?.users_notes;

				setBookingDataFromAPI((prev) => {
					if (!prev) return prev;
					if (Number(prev?.user_id) !== Number(updatedCustomer.id)) return prev;
					return {
						...prev,
						user_name: updatedCustomer?.name || prev?.user_name,
						user_number: updatedCustomer?.contact_number || prev?.user_number,
						...(latestNotes !== undefined ? { users_notes: latestNotes } : {}),
					};
				});

				setBookingDetails((prev) => {
					if (!prev) return prev;
					const customerId = prev?.user?.id ?? prev?.user_id;
					if (Number(customerId) !== Number(updatedCustomer.id)) return prev;
					return {
						...prev,
						...(latestNotes !== undefined ? { users_notes: latestNotes } : {}),
						user: prev?.user
							? {
								...prev.user,
								name: updatedCustomer?.name || prev?.user?.name,
								contact_number: updatedCustomer?.contact_number || prev?.user?.contact_number,
								...(latestNotes !== undefined ? { note: latestNotes, notes: latestNotes } : {}),
							}
							: prev?.user,
					};
				});

				setEditableBooking((prev) => {
					if (!prev) return prev;
					const customerId = prev?.user?.id ?? prev?.user_id;
					if (Number(customerId) !== Number(updatedCustomer.id)) return prev;
					return {
						...prev,
						...(latestNotes !== undefined ? { users_notes: latestNotes } : {}),
						user: prev?.user
							? {
								...prev.user,
								name: updatedCustomer?.name || prev?.user?.name,
								contact_number: updatedCustomer?.contact_number || prev?.user?.contact_number,
								...(latestNotes !== undefined ? { note: latestNotes, notes: latestNotes } : {}),
							}
							: prev?.user,
					};
				});

				setCustomerData((prev) => {
					if (!prev || Number(prev?.id) !== Number(updatedCustomer.id)) return prev;
					return {
						...prev,
						name: updatedCustomer?.name || prev?.name,
						contact_number: updatedCustomer?.contact_number || prev?.contact_number,
						...(latestNotes !== undefined ? { note: latestNotes, notes: latestNotes, users_notes: latestNotes } : {}),
					};
				});

				setBookingsList((prev) => {
					if (!Array.isArray(prev)) return prev;
					return prev.map((booking) => {
						const matches =
							Number(booking?.user_id) === Number(updatedCustomer.id) ||
							Number(booking?.user?.id) === Number(updatedCustomer.id);
						if (!matches) return booking;
						return {
							...booking,
							...(latestNotes !== undefined ? { users_notes: latestNotes } : {}),
							user: {
								...(booking?.user || {}),
								name: updatedCustomer?.name || booking?.user?.name,
								contact_number: updatedCustomer?.contact_number || booking?.user?.contact_number,
								...(latestNotes !== undefined ? { note: latestNotes, notes: latestNotes } : {}),
							},
						};
					});
				});
			};

			window.addEventListener("customerUpdated", handleCustomerUpdated);
			return () => {
				window.removeEventListener("customerUpdated", handleCustomerUpdated);
			};
		}, [setBookingDataFromAPI, setBookingDetails, setEditableBooking, setCustomerData, setBookingsList]);
		
	
		useEffect(() => {
			// Always set static values in itemData (preserve membership from prev during network fluctuations)
			// Prefer selectedOutlet (calendar source of truth) over selectedOutletData?.id — stale
			// getSelectedOutlet responses can leave selectedOutletData on the previous outlet.
			setItemData((prev) => ({
				...(prev || {}),
				company: 1,
				panel: "outlet",
				newsletter: 1,
				currency: "SGD",
				payment_type: "payatstore",
				payment_status: 1,
				type:"manual",
				service_at: selectedDate && selectedTime?.value? `${formatDateToDDMMYYYY(selectedDate)} ${selectedTime.value}`: (prev?.service_at ?? ""),
				created_by: loggedUser,
				outlet: selectedOutlet || selectedOutletData?.id,
				outlet_type: selectedOutletData?.outlet_type_id,
				source: itemData?.source || "WhatsApp",
				session_id: localSessionId,
				membership: typeof isMembershipApplied === "boolean" ? (isMembershipApplied ? 1 : 0) : (prev?.membership ?? 0),
				...(selectedDate && selectedTime && loggedUser !== null && selectedOutletData && temporaryBookingId ? {
					outlet: selectedOutlet || selectedOutletData?.id,
					outlet_type: selectedOutletData?.outlet_type_id,
					hold_booking_id: temporaryBookingId,
				} : {}),
			}));
		}, [loggedUser, selectedDate, selectedTime, selectedOutletData, selectedOutlet, setItemData, isMembershipApplied, temporaryBookingId, itemData?.source, localSessionId]);
		
		// NEW BOOKING CREATED START 
		const handleSubmit = async (e) => {
			if (setIsBookingSubmitting) setIsBookingSubmitting(true);
			setButtonDisabled(true);
			setIsSubmitting(true);
			// e.preventDefault();
			setApiError("");
			setApiErrorForCreateBooking("")
			setTherapistSelectionError("");

			if (validateFields()) {
				try {
					// Ensure membership is included (can be lost during network fluctuations when effects run out of order)
					// Force outlet from selectedOutlet so create matches therapist/calendar APIs.
					const payloadToSend = applyCalendarExpansionToPayloadItems({
						...itemData,
						outlet: selectedOutlet || itemData?.outlet,
						outlet_type: selectedOutletData?.outlet_type_id ?? itemData?.outlet_type,
						membership: typeof isMembershipApplied === "boolean" ? (isMembershipApplied ? 1 : 0) : (itemData?.membership ?? 0),
						selected_date: selectedDate ? formatDateToDDMMYYYY(selectedDate) : undefined,
					});

					const response = await postBookingData(payloadToSend);
					if (getApiSuccess(response)) {
						const createdNewBooking = response?.data?.data?.booking ?? response?.data?.booking;
						if (createdNewBooking) {
							setCreatedBooking(createdNewBooking);
							setCurrentStep("summary");
							lastResetBookingIdRef.current = createdNewBooking?.id;
							setBookingsList((prev) => {
								const filtered = prev.filter((booking) => {
								  const bookingId = Number(booking.id || booking.booking_id);
								  const bookingStatus = String(
									booking.status || booking.booking_status || ""
								  )
									.trim()
									.toLowerCase();
							  
								  return !(
									bookingId === Number(createdNewBooking?.id || createdNewBooking?.booking_id) &&
									bookingStatus === "holding"
								  );
								});
							  
								return [...filtered, createdNewBooking];
							});
							// Skip getBookingDetail2 refetch; use create response for summary
							skipDetailFetchForIdRef.current = createdNewBooking?.id;
							let bookingForDetails = createdNewBooking;
							if (
								bookingForDetails &&
								customerData?.id != null &&
								customerData.is_password_set !== undefined
							) {
								const passwordFlag = customerData.is_password_set;
								let user = bookingForDetails.user;
								if (Array.isArray(user)) {
									user = user.map((u) =>
										Number(u?.id) === Number(customerData.id)
											? { ...u, is_password_set: passwordFlag }
											: u
									);
								} else {
									user = {
										...(user && typeof user === "object" ? user : {}),
										id: customerData.id,
										name: customerData.name ?? user?.name,
										is_password_set: passwordFlag,
									};
								}
								bookingForDetails = { ...bookingForDetails, user };
							}
							setBookingDetails(bookingForDetails);
							setCustomerBookingItems(createdNewBooking?.booking_item ?? []);
							setSaleNote(createdNewBooking?.sales_note ?? '');
							setSelectedBookingId(createdNewBooking?.id);
							const newSid = createdNewBooking?.sale_id;
							setSelectedSaleId(newSid != null && newSid !== "" ? String(newSid) : null);
							scrollToBooking(createdNewBooking?.id);
						}

						
						setNewAppointmentSlots([]);
						setNewSlot(null);
						setIsNewBookingSlotActive(false);
						setEditPrefill(null);
						setShowConflictModal(false);
						setIsEditBookingActive(false);
						setItemData(null);
                        setSelectedServices([]);
                        setPaxes([]);
						if (customerData?.id != null && customerData?.is_password_set !== undefined) {
							storeCheckoutPasswordFlagFromCustomer(customerData);
						}
                        setCustomerData({});
						setIsCustomerSelected(false);
						
						setEditableBooking(null);
						setSelectedBookingDeleteScope(null);
						setSelectedBookingUpdateScope(null);
						setSelectedGuestCheckin({});
						setNewBookingActive(false);
						// setIsBookingInfoUpdated(true);
						bookingCreatedToast();
						setIsSubmitting(false);
						if (setIsBookingSubmitting) setIsBookingSubmitting(false);
						setShowBookingSummary(true);
						// Clear overlapping errors before resetting state
						setOverlappingErrors([]);
						resetSidebarState();
						setButtonDisabled(false);
						localStorage.removeItem('tempBookingID');
						setTemporaryBookingId(null);
						setTempBookingCreated(false);
						setHitTemporaryBookingApi(false);
						setCompleteBookingWarning(false);
						setShowPaymentInProgressNotice(false);
					} else {
						console.error("Booking failed:", response);
						const errorMessage = getApiMessage(response);
						setApiError(errorMessage);
						setApiErrorForCreateBooking(errorMessage);
						setButtonDisabled(false);
						setIsSubmitting(false);
						if (setIsBookingSubmitting) setIsBookingSubmitting(false);
					}
				} catch (error) {
					console.error("Error submitting booking:", error);
					const errorMessage = getApiMessage(error?.response?.data ?? error);
					setApiError(errorMessage);
					setApiErrorForCreateBooking(errorMessage);
					setButtonDisabled(false);
					setIsSubmitting(false);
					if (setIsBookingSubmitting) setIsBookingSubmitting(false);
				}
			} else {
				// Reset states when validation fails
				setButtonDisabled(false);
				setIsSubmitting(false);
				if (setIsBookingSubmitting) setIsBookingSubmitting(false);
			}
		};
		// NEW BOOKING CREATED END

		// NEW BOOKING CANCEL 
		const handleCancel = async (options = {}) => {
			const force = options === true || options?.force === true;
			if (!force && ((newAppointmentSlots.length > 0 && isCustomerSelected) || selectedServices.length > 0)) {
				setShowConflictModal(true);
				return;
			}else if(temporaryBookingId) {
				const response = await deleteHoldBooking(temporaryBookingId, selectedOutlet);
				if(response?.success || response?.data?.success || response?.status) {
					setTemporaryBookingId(null);
					setTempBookingCreated(false);
					setHitTemporaryBookingApi(false);
					localStorage.removeItem('tempBookingID');
				}
			}
			setSelectedCells(new Set());
			resetSidebarStateOnCancel();
			setCreatedBooking(null);
			setShowBookingSummary(false);
			setEditPrefill(null);
			setNewBookingActive(false);
			setNewAppointmentSlots([]);
			setNewSlot(null);
			setShowConflictModal(false);
			setTriggerCancel(true);
			setIsNewBookingSlotActive(false);
			setIsEditBookingActive(false);
			setCurrentStep("summary");
			resetCheckoutPricingState();
			if (onClose) {onClose();}
			setSelectedTime(() => bookingData?.time || null);
			setApiErrorForCreateBooking("");
			setDeletedBookingItemIds([]);
			setSidebarLoading(false);
		};
		
		
		
		useEffect(() => {
			if (triggerCancel) {
				handleCancel({ force: true });
				setTriggerCancel(false); // reset flag
			}
		}, [triggerCancel]);
		
		const handleClose = () => {
			setCreatedBooking(null);
			setShowBookingSummary(false);
			setEditPrefill(null);
			setNewBookingActive(false);
			setNewAppointmentSlots([]);
			setNewSlot(null);
			setShowConflictModal(false);
			setTriggerCancel(true);
			setIsNewBookingSlotActive(false);
			setIsEditBookingActive(false);
			setApiErrorForCreateBooking("")
			setEditableBooking(null);
			resetCheckoutPricingState();
			if (onClose) {onClose()}
			setSelectedBookingDeleteScope(null);
			setSelectedBookingUpdateScope(null);
			setDeletedBookingItemIds([]);
		};
		
		useEffect(() => {
			if (!shouldRenderRightSidebar || !newBookingActive) return;
			if (bookingDetails || (isEditBookingActive && editableBooking)) return;
			const focusCustomerInput = () => {
				const input = document.querySelector('input[type="search"][placeholder="Search or create customer"]');
				if (input) {
					input.focus();
					return true;
				}
				return false;
			};
			focusCustomerInput();
			const t1 = setTimeout(focusCustomerInput, 50);
			const t2 = setTimeout(focusCustomerInput, 150);
			return () => {
				clearTimeout(t1);
				clearTimeout(t2);
			};
		}, [shouldRenderRightSidebar, newBookingActive, bookingDetails, isEditBookingActive, editableBooking]);
		const minifiedVoucherDetail = voucherDetail.length > 0 ? JSON.stringify(voucherDetail) : null;
		
		// PAYMENT SUBMISSION START 
		const handleConfirmPayment = async ({ method, amount, partial, reference, payment_method_id, skip_password, skip_password_reason, selectedUserId, membershipId }) => {
			const paymentItem = {
				id: selectedBookingId || null,
				amount,
				// tip: parseFloat(paymentSummary.tip),
				// gst: parseFloat(paymentSummary.gst),
				// gst_rate: 9,
				payment_method_id: payment_method_id,
				currency: "SGD",
				sub_total: parseFloat(paymentSummary.subtotal),
				method: method,
				panel: "outlet",
				vouchers: minifiedVoucherDetail,
				reference: reference || "",
				updated_by: loggedUser,
				...(method === "cashless" ||
				method === "other_membership"
					? { skip_password: skip_password, skip_password_reason: skip_password_reason }
					: {}),
				...(selectedUserId ? { membership_user_id: selectedUserId } : {}),
				...buildMembershipIdPaymentFields(membershipId),
			}

			try {
			  const response = await postpaymentData(paymentItem);
			  if (response?.data?.success) {

				const newHistory = [
					...paymentHistory,
					{
						method,
						amount,
						id: selectedBookingId || null
					}
				];
				setPaymentHistory(newHistory);
				setPaymentSummary((prev) => ({...prev, payments: newHistory,}));
				
				let currentAmountDue =
					method === "cash"
						? roundCashAmount(parseFloat(amountDue))
						: parseFloat(amountDue);

				let updatedDue = currentAmountDue - amount;

				const newDue = updatedDue < 0 ? 0 : updatedDue;				
				
				setAmountDue(newDue.toFixed(2));
				
				setIsBookingInfoUpdated(true);
				
				if (newDue > 0) {
					setCurrentStep("payment");
				} else {
					setCurrentPaymentMethod("");
					setCurrentPaymentMethodTitle("");
					const closedBookingId = selectedBookingId ?? bookingDetails?.id;
					// Only mutate createdBooking when it is the same booking being closed
					if (
						createdBooking &&
						String(createdBooking.id ?? createdBooking.booking_id ?? "") === String(closedBookingId ?? "")
					) {
						createdBooking.status = "Completed";
					}

					// Update the existing booking in the list
					updateBookingStatus(setBookingsList, closedBookingId, "Completed");
					setNewAppointmentSlots([]);
					setNewSlot(null);
					setIsNewBookingSlotActive(false);
					setEditPrefill(null);
					setShowConflictModal(false);
					setIsNewBookingSlotActive(false);
					setIsEditBookingActive(false);
					setItemData(null);
					setSelectedServices([]);
					setPaxes([]);
					setCustomerData({});
					clearCheckoutCustomerIsPasswordSet();
					setCreatedBooking(null);
					setEditableBooking(null);
					setSelectedBookingDeleteScope(null);
					setSelectedBookingUpdateScope(null);
					paymentSuccessToast();
					setCurrentStep("saleinfo");
					// Update ref to prevent useEffect from resetting to "summary"
					lastResetBookingIdRef.current = closedBookingId;
					setCreatedBooking(null);			
					setNewAppointmentSlots([]);
					setNewSlot(null);
					setShowConflictModal(false);
					setIsEditBookingActive(false);
					scrollToBooking(closedBookingId);
					resetCheckoutPricingState();
				}
			  } else {
				console.error("Booking Status:", response);
			  }
			  return response;
			} catch (error) {
			  console.error("Error Booking Status:", error);
			  return error?.response || { success: false, message: error?.message || "Payment failed" };
			}
		};
		// PAYMENT SUBMISSION END 



		const handlePaymentReload = (failedResponse) => {
			resetCheckoutPricingState();
			setIsBookingInfoUpdated(true);
			setCurrentPaymentMethod("");
			setCurrentPaymentMethodTitle("");
			if (isBookingAlreadyCompletedResponse(failedResponse)) {
				const completedBookingId = selectedBookingId ?? bookingDetails?.id;
				updateBookingStatus(setBookingsList, completedBookingId, "Completed");
				lastResetBookingIdRef.current = completedBookingId;
				setCurrentStep("saleinfo");
				return;
			}
			setCurrentStep("checkout");
		};

		const handleConfirmationCancel = () => {
			setPaymentSummary((prev) => ({
				...prev,
				tip: "0.00",
				total: prev.midtotal,
			}));
			setCurrentStep("summary");
		};

		// ON CHECKOUT PAGE CANCEL PAYMENT START 
		const handleDiscardPayment = () => {
			if (bookingDetails?.booking_item) {
				Object.values(bookingDetails.booking_item).forEach((services) => {
					services.forEach((svc) => {
						if (svc.originalPrice !== undefined) {
							svc.price = svc.originalPrice;
						}
					});
				});
			}
			// Explicitly clear discount & member-rate overrides for this booking
			setDiscountByBookingItemId({});
			setMemberRateByBookingItemId({});
			setIsBookingInfoUpdated(true);
			setCurrentStep("summary");
			setIsDiscardPaymentPopupActive(false);
			setNewBookingActive(false);
			setNewAppointmentSlots([]);
			setNewSlot(null);
			setShowConflictModal(false);
			setIsEditBookingActive(false);
			resetCheckoutState();
		};
		// ON CHECKOUT PAGE CANCEL PAYMENT END 

		const handleCancelClick = async (cancelType) => {
			const cancelValue = typeof cancelType === "object"
				? cancelType.selected?.toLowerCase?.()
				: cancelType?.toLowerCase?.();
			// if (!selectedValue) return;
			setApiError("");
			setButtonDisabled(true);
			try {
				if (cancelValue === "deleted") {
					const response = await deleteBooking(selectedBookingId, selectedBookingDeleteScope);
					if (getApiSuccess(response)) {
						setBookingsList((prev) =>
							prev.filter((b) => 
								Number(b.id) !== Number(selectedBookingId) && 
								Number(b.booking_id) !== Number(selectedBookingId)
							)
						);
						if (onClose) {onClose();}
						setSelectedCells(new Set());
						setDeletedBookingID(selectedBookingId);
						setShowCancelPopup(false);
						setShowCancelWithRefundPopup(false);
						setShowRepeatPopup(false);
						bookingDeletedToast();
						setNewBookingActive(false);
						setNewAppointmentSlots([]);
						setNewSlot(null);
						setShowConflictModal(false);
						setIsEditBookingActive(false);
						setSelectedBookingDeleteScope(null);
						setButtonDisabled(false);
					}else {
						console.error("Booking delete failed:", response);
						setApiError(getApiMessage(response));
						setButtonDisabled(false);
				  }
				}
				if (cancelValue === "cancelled") {
					const postData = {
						"company": 1,
						"id": selectedBookingId || null,
						"panel": "outlet",
						"type": cancelValue,
						"reason": selectedReason || cancelType?.reason || null,
						"remark": selectedRemark || cancelType?.remark || null,
						"updated_by": loggedUser,
					};
					const response = await cancelBookingData(postData);
					if (getApiSuccess(response)) {
						updateBookingStatus(setBookingsList, selectedBookingId, "Cancelled");
						setShowCancelPopup(false);
						setShowCancelWithRefundPopup(false);
						setShowRepeatPopup(false);
						bookingCancelledToast();
						scrollToBooking(selectedBookingId);
						setIsBookingInfoUpdated(true);
						setNewBookingActive(false);
						setNewAppointmentSlots([]);
						setNewSlot(null);
						setShowConflictModal(false);
						setIsEditBookingActive(false);
						setSelectedBookingDeleteScope(null);
						setButtonDisabled(false);
					} else {
						setApiError(getApiMessage(response));
						setButtonDisabled(false);
					}
				}
				if (cancelValue === "no-show") {
					const statusData = {
						"company": 1,
						"id": selectedBookingId || null,
						"status": "No-show",
						"panel": "outlet",
						"updated_by": loggedUser,
					}
					const response = await postBookingStatus(statusData);
					if (getApiSuccess(response)) {
						updateBookingStatus(setBookingsList, selectedBookingId, "No-show");
						setShowCancelPopup(false);
						setShowCancelWithRefundPopup(false);
						setShowRepeatPopup(false);
						bookingNoShowToast();
						scrollToBooking(selectedBookingId);
						setIsBookingInfoUpdated(true);
						setNewAppointmentSlots([]);
						setNewSlot(null);
						setShowConflictModal(false);
						setIsEditBookingActive(false);
						setSelectedBookingDeleteScope(null);
						setButtonDisabled(false);
					} else {
						console.error("Booking Status:", response);
						setApiError(getApiMessage(response));
						setButtonDisabled(false);
					}

				}
			} catch (error) {
				console.error("Error submitting booking:", error);
				setButtonDisabled(false);
				setApiError(getApiMessage(error?.response?.data ?? error));
			}
		};
		

		const handleStatusChange = async (status) => {
			const statusData = {
				"company": 1,
				"id": selectedBookingId,
				"status": status,
				"panel": "outlet",
				"updated_by": loggedUser,
				outlet_type: selectedOutletData?.outlet_type_id,
			}
			setApiError("");
			try {
			  const response = await postBookingStatus(statusData);
			  if (getApiSuccess(response)) {
				updateBookingStatus(setBookingsList, selectedBookingId, status);
				setIsConfirmedAgainPopupActive(false);
				setIsVoidSalePopupActive(false);
				toast.success(`Booking ${status} successfully!`);
				scrollToBooking(selectedBookingId);
				setNewAppointmentSlots([]);
				setNewSlot(null);
				setShowConflictModal(false);
				setIsEditBookingActive(false);
				setIsBookingInfoUpdated(true);
			  } else {
				console.error("Booking Status:", response);
				setApiError(getApiMessage(response));
			  }
			} catch (error) {
			  console.error("Error Booking Status:", error);
			  setApiError(getApiMessage(error?.response?.data ?? error));
			}
		};


		const handleCheckout = () => {
			const bookingHasPriceAdjustmentObject = hasBookingPriceAdjustmentObject(
				bookingDetails?.booking_item
			);

			if (bookingDetails?.payment_status === "Paid") {
				setIsBookingInfoUpdated(true);
				setCurrentStep("summary"); // already paid, go to info screen
			} else if (bookingHasPriceAdjustmentObject) {
				setCurrentStep("checkout"); // not paid, proceed
				setIsAutoApply(true);
			} else {
				setCurrentStep("checkout"); // not paid, proceed
				setIsBookingInfoUpdated(true);
				setIsAutoApply(false);
			}
		};

		const restoreBookingDateTimeFromDetails = useCallback((details) => {
			if (!details) return;

			const serviceDate = details?.service_date;
			if (serviceDate) {
				const restoredDate = ensureDateObject(serviceDate);
				if (!Number.isNaN(restoredDate.getTime())) {
					setSelectedDate(restoredDate);
				}
			}

			const serviceTime = details?.service_time;
			if (serviceTime) {
				const valueTime = extractHHMM(serviceTime);
				if (valueTime) {
					const restoredTime = buildTimeSelection(
						valueTime,
						0,
						convertTo12Hour(valueTime),
						convertToMinutes(valueTime)
					);
					if (restoredTime) {
						setSelectedTime(restoredTime);
					}
				}
			}
		}, [setSelectedDate, setSelectedTime]);

		
		const { isBookingPaymentInProgress, isBookingCompleted } = getBookingPreventChanges(bookingDetails);
		const proceedToEditBooking = () => {
			setIsNewBookingSlotActive(false);
			setIsEditBookingActive(true);

			if (bookingDetails) {
				editBookingSnapshotRef.current = {
					serviceDate: bookingDetails?.service_date || null,
					bookingDetails,
					customerBookingItems,
				};
				resetActiveEditBookingContext(bookingDetails?.id);
				const liveBookingEntry = findLiveBookingListEntry(bookingsList, bookingDetails?.id);
				const liveGuestTagMap = buildLiveGuestTagMap(liveBookingEntry?.booking_item);
				const editableBookingWithLiveTags = Object.keys(liveGuestTagMap).length
					? {
						...bookingDetails,
						booking_item: mergeLiveGuestTagIntoBookingItemMap(bookingDetails?.booking_item, liveGuestTagMap),
					}
					: bookingDetails;
				setEditableBooking(editableBookingWithLiveTags);
			}

			if (isBookingPaymentInProgress) {
				setShowPaymentInProgressNotice(true);
				setCompleteBookingWarning(false);
			}
			if (isBookingCompleted) {
				setCompleteBookingWarning(true);
				setShowPaymentInProgressNotice(false);
			}

			setCurrentStep("editBooking");
		};

		// ONCLICK EDIT BOOKING START 
		const handleEditClick = async (bookingStatus = "") => {
			if (isViewOnlyOutlet) {
				toast.warning("You have view-only access for this outlet.");
				return;
			}
			const normalizedStatus = String(bookingStatus || "").toLowerCase();
			if (normalizedStatus === "completed") {
				setIsCompletedBookingEditProcessing(false);
				setCompletedBookingCanEdit(true);
				return;
			}
			setCompletedBookingCanEdit(false);
			setIsCompletedBookingEditProcessing(false);
			proceedToEditBooking();
		};
		// ONCLICK EDIT BOOKING END 

		// REFUND REQUEST START 
		const handleSendRefundReq = async (refundOptions = {}) => {
			const refundRemark = String(refundOptions?.remark || '').trim();
			const item = {
				booking: bookingDetails?.sale_id,
				remark: refundRemark || selectedRemark,
				reason: selectedReason,
				clawback_commission: Boolean(refundOptions.clawback_commission),
				booking_item_ids: Array.isArray(refundOptions.booking_item_ids) ? refundOptions.booking_item_ids : [],
				panel: 'outlet',
				updated_by: loggedUser,
			}
			if (!selectedReason) {
				return;
			}
			try {
				const response = await refundRequest(item);
				if (response?.data?.success) {
					refundSuccessToast();
					const postData = {
						"company": 1,
						"id": selectedBookingId || null,
						"panel": "outlet",
						"type": "",
						"reason": selectedReason,
						"remark": selectedRemark,
						"updated_by": loggedUser,
					};
					const response = await cancelBookingData(postData);
					if (response?.data?.success) {
						updateBookingStatus(setBookingsList, selectedBookingId, "Cancelled");
						setSelectedRemark("");
						setSelectedReason("");
						setShowCancelWithRefundPopup(false);
						setIsBookingInfoUpdated(true);
						bookingCancelledToast();
						scrollToBooking(selectedBookingId);
						setNewAppointmentSlots([]);
						setNewSlot(null);
						setShowConflictModal(false);
						setIsEditBookingActive(false);
					}
					setCurrentStep("saleinfo");
				} else {
					console.error("Refund failed:", response);
				}
			} catch (error) {
			console.error("Error submitting refund request:", error);
			}
		};
		// REFUND REQUEST END


		// VOID WITH REFUND REQUEST START 
		const handleSendRefundReqForVoid = async (refundOptions = {}) => {
			const refundRemark = String(refundOptions?.remark || '').trim();
			const item = {
				booking: bookingDetails?.sale_id,
				remark: refundRemark || selectedRemark,
				reason: selectedReason,
				clawback_commission: Boolean(refundOptions.clawback_commission),
				booking_item_ids: Array.isArray(refundOptions.booking_item_ids) ? refundOptions.booking_item_ids : [],
				panel: 'outlet',
				updated_by: loggedUser,
			}
			try {
				const response = await refundRequest(item);
				if (getApiSuccess(response)) {
					const refundSuccessMessage = getApiMessage(response, "Sale Voided");
					const statusData = {
						"company": 1,
						"id": selectedBookingId || null,
						status: "Voided",
						"panel": "outlet",
						"updated_by": loggedUser,
						isVoided: 1,
					};
					const statusResponse = await postBookingStatus(statusData);
					logger.log("this is called bro 5", statusResponse);
					if (getApiSuccess(statusResponse)) {
						setShowCancelWithRefundPopup(false);
						setIsBookingInfoUpdated(true);
						scrollToBooking(selectedBookingId);
						setNewAppointmentSlots([]);
						setNewSlot(null);
						setShowConflictModal(false);
						setIsEditBookingActive(false);
						setSelectedRemark("");
						setSelectedReason("");
						setIsVoidSalePopupActive(false);
						setAmountDue(0);
						toast.success(refundSuccessMessage);
						setApiError("");
						setCurrentStep("saleinfo");
						return;
					}

					const errorMessage = getApiMessage(statusResponse);
					setApiError(errorMessage);
					return { success: false, message: errorMessage };
				}

				console.error("Refund failed:", response);
				const errorMessage = getApiMessage(response);
				setApiError(errorMessage);
				return { success: false, message: errorMessage };
			} catch (error) {
				console.error("Error submitting refund request:", error);
				const errorMessage = getApiMessage(error?.response?.data ?? error);
				setApiError(errorMessage);
				return { success: false, message: errorMessage };
			}
		};
		// VOID WITH REFUND REQUEST END


		// ADD SALE/CHECKOUT NOTE START
		const openSaleNotePopup = () => {
			setSaleNoteError("");
			setIsSaleNotePopupActive(true);
		};

		const closeSaleNotePopup = () => {
			setSaleNoteError("");
			setIsSaleNotePopupActive(false);
		};

		const handleToAddSaleNote = async (note) => {
			const raw = selectedSaleId ?? bookingDetails?.sale_id;
			const id = raw != null && raw !== "" ? String(raw).replace(/#/g, "").trim() : null;
			const params = {
				id,
				panel: "outlet",
				note,
				updated_by: loggedUser,
			};
			setSaleNoteError("");
			setIsProcessingSaleNote(true);
			try {
			  const response = await addSaleNote(params);
			  if (response?.data?.success) {
				setSaleNote(note);
				setSaleNoteError("");
				closeSaleNotePopup();
				
			  } else {
				console.error("Add Note Status:", response);
				const errorMessage =
					response?.data?.message ||
					response?.message ||
					response?.response?.data?.message ||
					"Failed to save sale note. Please try again.";
				setSaleNoteError(errorMessage);
			  }
			} catch (error) {
			  console.error("Error Add Note Status:", error);
			  const errorMessage =
				error?.response?.data?.message ||
				error?.message ||
				"Failed to save sale note. Please try again.";
			  setSaleNoteError(errorMessage);
			} finally {
				setIsProcessingSaleNote(false);
			}
		}
		// ADD SALE/CHECKOUT NOTE END



		// CREATE TEMPORARY BOOKING START
		const tempBookingCreateInFlightRef = useRef(false);
		useEffect(() => {
			if (!hitTemporaryBookingApi || tempBookingCreated || tempBookingCreateInFlightRef.current) {
			  return;
			}
			if (
			  !loggedUser ||
			  !newAppointmentSlots?.length ||
			  !selectedOutlet ||
			  !customerData?.id ||
			  !selectedDate ||
			  !selectedTime?.value ||
			  !localSessionId
			) {
			  return;
			}
			// Don't create temporary booking if itemData?.items already has data
			if (itemData?.items) {
				// Check if it's an array with items
				if (Array.isArray(itemData.items) && itemData.items.length > 0) {
					return;
				}
				// Check if it's a non-empty string (JSON stringified) with actual data
				if (typeof itemData.items === 'string' && itemData.items.trim().length > 0) {
					try {
						const parsed = JSON.parse(itemData.items);
						// Only return if parsed data is an array with items (not empty array "[]")
						if (Array.isArray(parsed) && parsed.length > 0) {
							return;
						}
					} catch (e) {
						// If it's not valid JSON but is a non-empty string, assume it has data
						return;
					}
				}
			}
			const tempItemsArray = [
			  {
				service: newAppointmentSlots[0]?.serviceId || null,
				therapist: newAppointmentSlots[0]?.therapistId,
				room_id: newAppointmentSlots[0]?.roomId,
				room_segments: [
				  {
					room_id: newAppointmentSlots[0]?.roomId,
					item_type: newAppointmentSlots[0]?.roomName,
				  },
				],
				start_time: selectedTime?.value,
				end_time: calculateEndTime(selectedTime?.value, 40),
				duration: 40,
				quantity: '1',
				price: '0',
				service_request: '',
				primary: 0,
				item_number: 0,
				splited: false,
				parent_booking_item_id: null,
				customer_name: customerData?.name,
				session_id: localSessionId,
			  },
			];
			
			// Only proceed if tempItems array is not empty
			if (!tempItemsArray || tempItemsArray.length === 0) {
				return;
			}
			
			const tempItems = JSON.stringify(tempItemsArray);
			const createTempBooking = async () => {
			  tempBookingCreateInFlightRef.current = true;
			  const payloadForTemporaryBooking = applyCalendarExpansionToPayloadItems({
				user_id: loggedUser,
				service_at: `${formatDateToDDMMYYYY(selectedDate)} ${selectedTime?.value}`,
				outlet_id: selectedOutlet,
				customer_id: customerData?.id,
				items: tempItems,
				panel: 'outlet',
			  });
		  
			  try {
				const response = await createTemporaryBooking(payloadForTemporaryBooking);
				if (response?.status) {
				  const id = response?.data?.booking_id;
				  localStorage.setItem('tempBookingID', id);
				  setTemporaryBookingId(id || null);
				  setHitTemporaryBookingApi(false);
				  setTempBookingCreated(true);
				} else {
				  console.error("Temporary Booking Creation Failed:", response);
				}
			  } catch (error) {
				console.error("Error Creating Temporary Booking:", error);
			  } finally {
				tempBookingCreateInFlightRef.current = false;
			  }
			};
		  
			createTempBooking();
		  }, [
			hitTemporaryBookingApi,
			tempBookingCreated,
			loggedUser,
			newAppointmentSlots,
			selectedOutlet,
			customerData?.id,
			customerData?.name,
			selectedDate,
			selectedTime?.value,
			localSessionId,
			itemData?.items,
		  ]);
		// CREATE TEMPORARY BOOKING END


		// UPDATE TEMPORARY BOOKING START
		const lastApiCallItemsRef = useRef(null);		
		useEffect(() => {
			if (
				!loggedUser ||
				!newAppointmentSlots?.length ||
				!itemData?.service_at ||
				!selectedOutlet ||
				!customerData?.id ||
				!temporaryBookingId ||
				!tempBookingCreated
			  ) {
				return;
			  }

			let itemsArray;
			const isArrayType = Array.isArray(itemData?.items);
			const latestItemsFromContext = Array.isArray(items) ? items : [];
			
			// Prefer global `items` as source of truth; `itemData.items` can be stale during rapid drag/update effects.
			if (latestItemsFromContext.length > 0) {
				itemsArray = latestItemsFromContext.map((item) => ({ ...item }));
			} else if (isArrayType) {
				itemsArray = itemData.items;
			} else if (typeof itemData?.items === 'string') {
				try {
					itemsArray = JSON.parse(itemData.items);
				} catch (e) {
					console.error("Failed to parse itemData.items:", e);
					return;
				}
			} else {
				return;
			}

			const tempItemsArray = [
				{
					service: newAppointmentSlots[0]?.serviceId || null,
					therapist: newAppointmentSlots[0]?.therapistId,
					room_id: newAppointmentSlots[0]?.roomId,
					room_segments: [
						{
							room_id: newAppointmentSlots[0]?.roomId,
							item_type: newAppointmentSlots[0]?.roomName,
						},
					],
					start_time: selectedTime?.value,
					end_time: calculateEndTime(selectedTime?.value, 40),
					start_date: formatDateToDDMMYYYY(selectedDate),
					duration: 40,
					quantity: '1',
					price: '0',
					service_request: '',
					primary: 0,
					item_number: 0,
					splited: false,
					parent_booking_item_id: null,
					customer_name: customerData?.name,
					session_id: localSessionId,
				},
			];

			if (Array.isArray(itemsArray) && itemsArray.length === 0) {
				itemsArray = tempItemsArray;
			}

			// Context items never persist session_id; attach it on the payload we send.
			const itemsToSend = itemsArray.map((item) => ({
				...item,
				session_id: item.session_id || localSessionId,
			}));
			
			const itemsString = JSON.stringify({
				booking_id: temporaryBookingId,
				items: itemsToSend,
			});
			if (lastApiCallItemsRef.current === itemsString) {
				return;
			}
			
			lastApiCallItemsRef.current = itemsString;
			
			const updateTempBooking = async () => {
				const payloadForUpdateTemporaryBooking = {
					user_id: loggedUser,
					service_at: itemData?.service_at,
					outlet_id: selectedOutlet,
					customer_id: customerData?.id,
					items: isArrayType ? itemsToSend : JSON.stringify(itemsToSend),
					booking_id: temporaryBookingId,
					panel: 'outlet',
					view_type: 'calendar'
					};
				const response = await updateTemporaryBooking(payloadForUpdateTemporaryBooking);
				if (response?.status) {
				} else {
					console.error("Temporary Booking Update Failed:", response);
				}
			}
			updateTempBooking();
		}, [itemData?.items, items, temporaryBookingId, tempBookingCreated, localSessionId]);	
		// UPDATE TEMPORARY BOOKING END


		useEffect(() => {
			if ((!selectedServices || selectedServices.length === 0) && 
				(!paxes || paxes.length === 0)) {
				return;
			}
	
			const hasMissingRoomInSelected = selectedServices?.some(
				(service) => !hasServiceRoomAssignment(service)
			) || false;
	
			const hasMissingRoomInPaxes = paxes?.some(
				(pax) => pax.selectedServices?.some((service) => !hasServiceRoomAssignment(service))
			) || false;
	
			setNoRoomSelected(hasMissingRoomInSelected || hasMissingRoomInPaxes);
		}, [selectedServices, paxes, setNoRoomSelected]);
		
		
		// Comprehensive validation for booking
		const canBook = (() => {
			// Basic requirements
			if (!itemData?.customer) return false;
			if (selectedServices.length === 0) return false;
			
			// Get all services (main + pax)
			const allServices = getAllDraftServices();
			
			if (allServices.length === 0) return false;

			// Therapist is validated on submit (validateFields) so the user sees why booking is blocked.
			return allServices.every((service) => hasServiceRoomAssignment(service));
		})();

		const allDraftServicesHaveTherapists = getAllDraftServices().every(
			(service) => getServiceTherapistId(service) != null
		);

		useEffect(() => {
			if (allDraftServicesHaveTherapists) {
				setTherapistSelectionError("");
			}
		}, [allDraftServicesHaveTherapists]);


		if (!shouldRenderWrapper) {
			return null;
		}

		return (
			<div
				ref={setSidebarNode}
				className={`${styles.rightSidebar} ${currentStep === "payment" ? styles.isPaymentStep : ''} ${shouldRenderRightSidebar ? styles.show : ''} ${isSidebarLoading ? styles.overlay : ''} rightSidebarFilter`}>
			{currentStep !== "payment" && (
				<button
					type="button"
					className={styles.mobileCloseButton}
					onClick={handleClose}
					aria-label="Close sidebar">
					<img src={BackIcon} alt="" />
				</button>
			)}
				{/* {(isBookingSidebar || showBookingSummary) && bookingDetails ? ( */}
				{(bookingDetails || (isEditBookingActive && editableBooking)) ? (
					(() => {
						switch (currentStep) {
							case "summary":
								return (
									<>
										<BookingInfo
											// repeatBookingDates={repeatBookingDates}
											// loading={loading}
											editLoading={editLoading}
											onCheckout={handleCheckout}
											onShowCancelPopup={(bookingStatus, bookingDeposit) => {
												setCancelPopupBookingStatus(bookingStatus || "");
												setCancelPopupBookingDeposit(bookingDeposit ?? null);
												setShowCancelPopup(true);
											}}
											onShowCancelWithRefundPopup={(bookingStatus, bookingDeposit) => {
												setCancelPopupBookingStatus(bookingStatus || "");
												setCancelPopupBookingDeposit(bookingDeposit ?? null);
												setShowCancelWithRefundPopup(true);
											}}
											onEdit={(isCrossDayBooking) => handleEditClick(isCrossDayBooking)}
											confirmedAgainPopup={() => setIsConfirmedAgainPopupActive(true)}
											setCurrentStep={setCurrentStep}
											onViewSale={handleViewSale}
											handleStatus={handleStatusChange}
											showAddNotePopup={openSaleNotePopup}
											saleNote={saleNote}
											showRepeatPopup={() => setShowRepeatPopup(true)}
											/>
										{showCancelPopup && (
											<CancelBookingPopup
											onClose={() => {
												setApiError("");
												setShowCancelPopup(false);
												setSelectedRemark("");
												setSelectedReason("");
											}}
											onConfirm={handleCancelClick}
											buttonDisabled={buttonDisabled}
											bookingStatus={cancelPopupBookingStatus}
											bookingDeposit={cancelPopupBookingDeposit}
											nextStep={() => {
												// If the UI needs a refund flow, switch modals instead of crashing on an undefined nextStep.
												setShowCancelPopup(false);
												setShowCancelWithRefundPopup(true);
											}}
											/>
										)}
										{showCancelWithRefundPopup && (
											<CancelBookingWithRefund
											onClose={() => {
												setApiError("");
												setShowCancelWithRefundPopup(false);
												setSelectedRemark("");
												setSelectedReason("");
											}}
											onConfirm={handleCancelClick}
											sendRefundReq={handleSendRefundReq}
											cancellBookingWithoutRefund={handleCancelClick}
											buttonDisabled={buttonDisabled}
											bookingStatus={cancelPopupBookingStatus}
											bookingDeposit={cancelPopupBookingDeposit}
											/>
										)}
										{isConfirmedAgainPopupActive && (
											<ConfirmedAgainPopup
											onClose={() =>setIsConfirmedAgainPopupActive(false)}
											onConfirm={() => handleStatusChange('Confirmed')}
											/>
										)}
										{isSaleNotePopupActive && (
											<SaleNotePopup 
												addSaleNote={handleToAddSaleNote}
												onClose={closeSaleNotePopup}
												editableNote={saleNote}
												isProcessing={isProcessingSaleNote}
												apiError={saleNoteError}
											/>
										)}
										{showRepeatPopup && (
											<RepeatBookingPopup
											onClose={() => setShowRepeatPopup(false)}
											/>
										)}
										{completedBookingCanEdit && (
											<CompletedBookingCanEditPopup
											onClose={() => {
												setCompletedBookingCanEdit(false);
												setIsCompletedBookingEditProcessing(false);
											}}
											isProcessing={isCompletedBookingEditProcessing}
											onConfirm={() => {
												setIsCompletedBookingEditProcessing(true);
												setTimeout(() => {
													proceedToEditBooking();
													setCompletedBookingCanEdit(false);
													setIsCompletedBookingEditProcessing(false);
												}, 0);
											}}
											/>
										)}
										{apiError && !showCancelPopup && !showCancelWithRefundPopup && (
											<div className={styles.overlappingErrorContainer}>
												<div className={styles.errorMessage}>{apiError}</div>
											</div>
										)}
									</>
								);
							case "checkout":
								return (
									<>
										<CheckoutPage
											items={items}
											onBack={() => setCurrentStep("summary")}
											onNext={() => setCurrentStep("payment")}
											discardPaymentPopup={() => setIsDiscardPaymentPopupActive(true)}
											showAddNotePopup={openSaleNotePopup}
											saleNote={saleNote}
										/>
										{isDiscardPaymentPopupActive && (
											<DiscardPaymentPopup
											onClose={() =>setIsDiscardPaymentPopupActive(false)}
											onConfirm={handleDiscardPayment}
											/>
										)}
										{isSaleNotePopupActive && (
											<SaleNotePopup 
												addSaleNote={handleToAddSaleNote}
												onClose={closeSaleNotePopup}
												editableNote={saleNote}
												isProcessing={isProcessingSaleNote}
												apiError={saleNoteError}
											/>
										)}
									</>
								);
							case "payment":
								return (
									<PaymentPage
										onBack={() => {setCurrentStep("checkout"); setCurrentPaymentMethod(""); setCurrentPaymentMethodTitle("");}}
										onNext={() => setCurrentStep("confirmation")}
										onReload={handlePaymentReload}
										completeBooking={handleConfirmPayment}
										setCurrentStep={setCurrentStep}
										onTopUpClick={openCheckoutMembershipFlow}
										onOpenMembershipSale={openMembershipSaleRecovery}
										customerCreditRefreshKey={checkoutTopupRefreshKey}
									/>
								);
							case "confirmation":
								return (
									<ConfirmationPage
										summary={paymentSummary}
										onBack={() => {setCurrentStep("payment"); setCurrentPaymentMethod(""); setCurrentPaymentMethodTitle("");}}
										onReload={handlePaymentReload}
										onConfirm={handleConfirmPayment}
										onCancel={handleConfirmationCancel}
										onMembershipClientTopUpClick={openCheckoutMembershipFlow}
										onOpenMembershipSale={openMembershipSaleRecovery}
										selectedOthersMembershipClient={othersMembershipClient}
										onOthersMembershipClientChange={setOthersMembershipClient}
										customerCreditRefreshKey={checkoutTopupRefreshKey}
										creditFetchUserId={
											othersMembershipClient?.user_id ?? resolveTopupUserId()
										}
									/>
								);
							case "saleinfo":
								return (
									<>
										<SaleInfoPage
											summary={paymentSummary}
											showAddNotePopup={openSaleNotePopup}
											showVoidSalePopup={() => setIsVoidSalePopupActive(true)}
											saleNote={saleNote}
											isSalesFlow={false}
										/>
										{isSaleNotePopupActive && (
											<SaleNotePopup 
												addSaleNote={handleToAddSaleNote}
												onClose={closeSaleNotePopup}
												editableNote={saleNote}
												isProcessing={isProcessingSaleNote}
												apiError={saleNoteError}
											/>
										)}
										
										{isVoidSalePopupActive && (
											<VoidSalePopup
												onClose={() => setIsVoidSalePopupActive(false)}
												voidSaleWithoutRefund={() => handleSendRefundReqForVoid()}
												sendRefundReq={handleSendRefundReq}
												voidedSaleWithRefund={handleSendRefundReqForVoid}
												bookingDataFromAPI={{
													booking_id: selectedBookingId,
													sale_id: selectedSaleId || bookingDetails?.sale_id,
													type: "booking"
												}}
												from="salePage"
											/>
										)}	

									</>
								);
							case "editBooking":
								return (
									<EditSidebarWrapper
										setShowBookingSummary={setShowBookingSummary}
										editLoading={editLoading}
										prefill={editPrefill}
										isOutletExtended={isOutletExtended}
										onClose={() => {
											// Clear edit booking API error so it does not stick on summary after Cancel/Reload
											setApiError("");
											// Notify Home to clear any persisted drag overrides for this booking on cancel
											try {
												window.dispatchEvent(new CustomEvent('cancelEditOverride', { detail: { bookingId: selectedBookingId } }));
											} catch {}

											const snapshot = editBookingSnapshotRef.current;
											const currentDateStr = selectedDate
												? formatDateToDDMMYYYY(selectedDate)
												: null;
											const dateChangedDuringEdit = Boolean(
												snapshot?.serviceDate &&
												currentDateStr &&
												currentDateStr !== snapshot.serviceDate
											);

											if (dateChangedDuringEdit && snapshot?.bookingDetails) {
												setBookingDetails(snapshot.bookingDetails);
												if (snapshot.customerBookingItems) {
													setCustomerBookingItems(snapshot.customerBookingItems);
												}
												restoreBookingDateTimeFromDetails(snapshot.bookingDetails);
												skipDetailFetchForIdRef.current = selectedBookingId;
												setBookingChanged(false);
												setHitTemporaryBookingApi(false);
											}

											editBookingSnapshotRef.current = null;
											setCurrentStep("summary");
											setEditPrefill(null);
											setNewAppointmentSlots([]);
											setNewSlot(null);
											setSelectedServices([]);
											setIsCustomerSelected(false);
											setShowConflictModal(false);
											setIsNewBookingSlotActive(false);
											setIsEditBookingActive(false);
											setEditableBooking(null);
											setNewBookingActive(false);
											setSelectedGuestCheckin({});
											setDeletedBookingItemIds([]);
											try {setDateSyncState({requestId: 0,mode: null,status: "idle",date: null,});} catch {}
										}}

										onUpdate={() => { 
											editBookingSnapshotRef.current = null;
											setCurrentStep("summary");
											setEditPrefill(null);
											setNewAppointmentSlots([]);
											setNewSlot(null);
											setSelectedServices([]);
											setIsCustomerSelected(false);
											setShowConflictModal(false);
											setIsNewBookingSlotActive(false);
											setIsEditBookingActive(false);
											setEditableBooking(null);
											setNewBookingActive(false);
											setSelectedGuestCheckin({});
											setDeletedBookingItemIds([]);
											try {setDateSyncState({requestId: 0,mode: null,status: "idle",date: null,});} catch {}
										 }}
									/>
								);
							default:
								return null;
						}
					})()
				) : newBookingActive ? (
					<>
						<div className={styles.rightHeader}>
							<h5>New Booking</h5>
							<BorderedButton
								text="Cancel"
								className={styles.cancelButton}
								onClick={handleCancel}
							/>
						</div>

						<div className={styles.divWrapper}>
							<div className={styles.divHeight} ref={scrollableRef}>
								<DateTimeOutletSelector interval={interval} />
								<CustomerSelector
									key={formResetKey}
									resetTrigger={formResetKey}
									error={customerError}
									setError={setCustomerError}
									setApiErrorForCreateBooking={setApiErrorForCreateBooking}
									handleGetGuestCheckinList={handleGetGuestCheckinList}
									handleSelectGuestCheckin={(user) => handleSelectGuestCheckin(user, 'customer')}
									selectedGuestCheckin={getSelectedGuestCheckin('customer')}
									guestCheckinList={guestCheckinList}
									guestCheckinRemoteList
									onGuestCheckinSearchQueryChange={scheduleGuestCheckinSearch}
									onGuestCheckinLoadMore={handleGuestCheckinLoadMore}
									guestCheckinHasMore={guestCheckinHasMore}
									guestCheckinLoadingMore={guestCheckinLoadingMore}
								/>

								{(itemData?.customer ||
									selectedServices.length > 0 ||
									paxes.length > 0) && (
									<ServiceSelector
										bookingDetails={bookingDetails}
										error={serviceError}
										setError={setServiceError}
										interval={interval}
										isOutletExtended={isOutletExtended}
										bookingChanged={bookingChanged}
										handleGetGuestCheckinList={handleGetGuestCheckinList}
										handleSelectGuestCheckin={handleSelectGuestCheckin}
										getSelectedGuestCheckin={getSelectedGuestCheckin}
										guestCheckinList={guestCheckinList}
										guestCheckinRemoteList
										onGuestCheckinSearchQueryChange={scheduleGuestCheckinSearch}
										onGuestCheckinLoadMore={handleGuestCheckinLoadMore}
										guestCheckinHasMore={guestCheckinHasMore}
										guestCheckinLoadingMore={guestCheckinLoadingMore}
							onRoomConflictChange={setRoomConflictErrors}
									/>
								)}

								<SourceSelector
									// setSourceSelected={setSourceSelected}
									error={sourceError}
									setError={setSourceError}
								/>

								{itemData?.source && <PriceSummary />}
								{itemData?.source && <Notes />}

                               {/* ERRORS CONTAINER START  */}
							   {!isSubmitting && (overlappingErrors.length > 0 || roomConflictErrors.length > 0 || apiErrorForCreateBooking || therapistSelectionError || isGreyBox) && (
								<div className={`${styles.overlappingErrorContainer} ${canBook && styles.bottom}`}>
									{!isSubmitting && overlappingErrors.length > 0 && ( 
										<div>
											{/* Show the multi-therapist overlap message only once */}
											{overlappingErrors.some((e) => e.isCustomerTimeOverlap) && (
												<div className={styles.errorMessage}>Appointments overlap with multiple therapists</div>
											)}
										
											{/* Render other errors normally */}
											{overlappingErrors
												.filter((e) => !e.isCustomerTimeOverlap)
												.map((error, index) => (
													<div key={`err-${index}`} className={styles.errorMessage}>
														{error.isOverlappingWithBreaks
															? `Booking overlaps with ${error.therapistName}'s break`
															: `One of more services have the same time`}
													</div>
												))}
										</div>
									)}

									{!isSubmitting && roomConflictErrors.length > 0 && (
										<div>
											{Array.from(new Set(roomConflictErrors)).map((message, index) => (
												<div key={`room-conflict-${index}`} className={styles.errorMessage}>
													{message}
												</div>
											))}
										</div>
									)}

									{therapistSelectionError && (
										<div className={styles.errorMessage}>{therapistSelectionError}</div>
									)}

									{apiErrorForCreateBooking && (
										<div className={styles.errorMessage}>{apiErrorForCreateBooking}</div>
									)}

					
									
									{isGreyBox && (isRoomFilterActive || therapistDisplayName) && (
										<div className={styles.errorMessage}>
											{isRoomFilterActive 
												? "Outlet is closed, want to proceed?" 
												: `Booking outside of ${therapistDisplayName}'s working hours`}
										</div>
									)}
								</div>
								)}
								{/* ERRORS CONTAINER END  */}
							</div>
							
						</div>
						
						<div className={styles.bookBtnContainer}>
						{canBook && (
								<PrimaryButton
								type="button"
								className={`
									${styles.fullWidthBtn}
									rounded-0
								`}
								disabled={isSubmitting}
								text={isSubmitting ? "Processing..." : "Book Appointment"}
								onClick={handleSubmit}
								/>
							)}

						</div>
						{/* Invisible element at the bottom for scrolling */}
						<div ref={bottomRef} style={{ height: '1px' }} />
					</>
				) : (
					<div className={styles.noBookingActiveContainer}>
						<h4>Please wait... </h4>
					</div>
				)}

				{isCheckoutTopupOpen && (
					<CustomerDetailsModal
						key={`topup-${checkoutTopupCustomer?.id ?? resolveTopupUserId() ?? "sale"}`}
						customer={checkoutTopupCustomer ?? buildTopupCheckoutCustomer()}
						isOpen={isCheckoutTopupOpen}
						onClose={() => {
							restoreCheckoutPaymentMethodAfterTopup();
							checkoutTopupTargetCustomerRef.current = null;
							setCheckoutTopupCustomer(null);
							setCheckoutRecoveryMembershipSale(null);
							setIsOthersMemberTopupFlow(false);
							setIsCheckoutTopupOpen(false);
						}}
						autoOpenMembershipFlow={checkoutRecoveryMembershipSale ? null : checkoutMembershipFlowType}
						recoveryMembershipSale={checkoutRecoveryMembershipSale}
						membershipFlowOnly={true}
						skipSetMembershipPasswordAfterPayment={isOthersMemberTopupFlow}
						onMembershipPaymentSuccess={handleCheckoutTopupPaymentSuccess}
					/>
				)}

			</div>
		);
	}
);

export default RightSidebarWrapper;
